import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.some.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _initializerDefineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _applyDecoratedDescriptor from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

import Base from "./Base";
import { computed, makeObservable, observable, reaction, runInAction } from "mobx";
import { ReservationBoxRefs, ReservationModel, ReservationSelectedCTA } from "./models";
import dpservices from "@dp/services";
import moment from "moment";
import { PlatformType, formatPhoneNumber } from "@dp/common";
import toInteger from "lodash/toInteger";
import i18next from "i18next";
import BrandRules from "../utils/BrandRules";
var Reservation = (_class = /*#__PURE__*/function (_Base) {
  _inherits(Reservation, _Base);

  var _super = _createSuper(Reservation);

  function Reservation(rootStore) {
    var _this$rootStore3, _this$rootStore3$user;

    var _this;

    _classCallCheck(this, Reservation);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "rootStore", void 0);

    _defineProperty(_assertThisInitialized(_this), "reservationModel", void 0);

    _initializerDefineProperty(_assertThisInitialized(_this), "_isReserveClicked", _descriptor, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_isEditReservation", _descriptor2, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_isEmailEditLink", _descriptor3, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_sessionDetails", _descriptor4, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_isReservationFormDirty", _descriptor5, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_appAttributes", _descriptor6, _assertThisInitialized(_this));

    _defineProperty(_assertThisInitialized(_this), "analyticsModel", void 0);

    _defineProperty(_assertThisInitialized(_this), "selectLocation", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(restaurant) {
        var _this$reservationMode, _this$reservationMode2, _restaurant$contactDe, _restaurant$contactDe2;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _this.reservationModel.isChangeLocationModalOpen = false;

                if (((_this$reservationMode = _this.reservationModel) === null || _this$reservationMode === void 0 ? void 0 : (_this$reservationMode2 = _this$reservationMode.restDetails) === null || _this$reservationMode2 === void 0 ? void 0 : _this$reservationMode2.restaurantNumber) !== (restaurant === null || restaurant === void 0 ? void 0 : restaurant.restaurantNumber)) {
                  _this.reservationModel.restDetails = restaurant;
                }

                _this.reservationModel.selectedLocationState = (_restaurant$contactDe = restaurant.contactDetail) === null || _restaurant$contactDe === void 0 ? void 0 : (_restaurant$contactDe2 = _restaurant$contactDe.address) === null || _restaurant$contactDe2 === void 0 ? void 0 : _restaurant$contactDe2.stateName;

                _this.validateDefaultValues();

                _this.advanceDateIfRequired(restaurant === null || restaurant === void 0 ? void 0 : restaurant.closedDays);

                _context.next = 8;
                return _this.getRestaurantTimeslots();

              case 8:
                _context.next = 10;
                return _this.getRestaurantAvailableSlots();

              case 10:
                _context.next = 14;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](0);

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 12]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "navigateToReservations", function () {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      var bottomTabsContainReservations = _this.isBottomTabsContainReservations();

      if (bottomTabsContainReservations) {
        var _this$rootStore, _this$rootStore$platf;

        (_this$rootStore = _this.rootStore) === null || _this$rootStore === void 0 ? void 0 : (_this$rootStore$platf = _this$rootStore.platformUtil) === null || _this$rootStore$platf === void 0 ? void 0 : _this$rootStore$platf.navigateToRoute("/ReservationsWithTopTabsInBottomTab", params);
      } else {
        var _this$rootStore2, _this$rootStore2$plat;

        (_this$rootStore2 = _this.rootStore) === null || _this$rootStore2 === void 0 ? void 0 : (_this$rootStore2$plat = _this$rootStore2.platformUtil) === null || _this$rootStore2$plat === void 0 ? void 0 : _this$rootStore2$plat.navigateToRoute("/ReservationsWithTopTabsAsAScreen", params);
      }
    });

    _this.rootStore = rootStore;
    _this.reservationModel = new ReservationModel(_this.rootStore.platformUtil);
    _this.analyticsModel = (_this$rootStore3 = _this.rootStore) === null || _this$rootStore3 === void 0 ? void 0 : (_this$rootStore3$user = _this$rootStore3.user) === null || _this$rootStore3$user === void 0 ? void 0 : _this$rootStore3$user.analyticsModel;

    _this.rootStore.user.analyticsModel.setChangeErrorPageNameWithoutRD(true);

    makeObservable(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Reservation, [{
    key: "_processSessionDetails",
    value: function _processSessionDetails(session) {
      var _this2 = this;

      runInAction(function () {
        _this2._sessionDetails = session;
      });
    }
  }, {
    key: "_processAppAttributes",
    value: function () {
      var _processAppAttributes2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(appAttributes) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this._appAttributes = appAttributes;
                this.reservationModel.setAttributes(appAttributes);

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function _processAppAttributes(_x2) {
        return _processAppAttributes2.apply(this, arguments);
      }

      return _processAppAttributes;
    }()
  }, {
    key: "setupReactions",
    value: function setupReactions() {
      var _this3 = this;

      reaction(function () {
        var _this3$rootStore, _this3$rootStore$user;

        return {
          detail: (_this3$rootStore = _this3.rootStore) === null || _this3$rootStore === void 0 ? void 0 : (_this3$rootStore$user = _this3$rootStore.user) === null || _this3$rootStore$user === void 0 ? void 0 : _this3$rootStore$user.sessionDetails
        };
      }, /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(data) {
          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _this3._processSessionDetails(data === null || data === void 0 ? void 0 : data.detail);

                case 1:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        return function (_x3) {
          return _ref2.apply(this, arguments);
        };
      }());
      reaction(function () {
        return {
          appAttributes: _this3.rootStore.common.appAttributes
        };
      }, function (data) {
        _this3._processAppAttributes(data.appAttributes);
      });
      reaction(function () {
        return {
          isLoggedIn: _this3.rootStore.user.isLoggedIn,
          userProfile: _this3.rootStore.user.userProfile
        };
      }, function (data) {
        _this3._processUserProfile(data.isLoggedIn, data.userProfile);
      });
      reaction(function () {
        return {
          detail: _this3.reservationModel.restDetails
        };
      }, /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(data) {
          return _regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  _this3.dispatchReservationChangeLocationEvent();

                  _this3.analyticsModel.setRestaurantDetailData(data === null || data === void 0 ? void 0 : data.detail);

                case 2:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4);
        }));

        return function (_x4) {
          return _ref3.apply(this, arguments);
        };
      }());
      reaction(function () {
        var _this3$reservationMod, _this3$reservationMod2, _this3$reservationMod3;

        return {
          restaurantNum: (_this3$reservationMod = _this3.reservationModel) === null || _this3$reservationMod === void 0 ? void 0 : (_this3$reservationMod2 = _this3$reservationMod.restDetails) === null || _this3$reservationMod2 === void 0 ? void 0 : _this3$reservationMod2.restaurantNumber,
          confirmationNumber: (_this3$reservationMod3 = _this3.reservationModel) === null || _this3$reservationMod3 === void 0 ? void 0 : _this3$reservationMod3.confirmationNumber
        };
      }, /*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(data) {
          var _data$restaurantNum;

          return _regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  if (data !== null && data !== void 0 && data.confirmationNumber && data !== null && data !== void 0 && data.restaurantNum) _this3._getPdfMenuUrl(data === null || data === void 0 ? void 0 : (_data$restaurantNum = data.restaurantNum) === null || _data$restaurantNum === void 0 ? void 0 : _data$restaurantNum.toString());

                case 1:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5);
        }));

        return function (_x5) {
          return _ref4.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var _this$rootStore4, _this$rootStore4$user, _this$rootStore5, _this$rootStore5$user, _this$rootStore6, _this$rootStore6$user;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                this._processSessionDetails((_this$rootStore4 = this.rootStore) === null || _this$rootStore4 === void 0 ? void 0 : (_this$rootStore4$user = _this$rootStore4.user) === null || _this$rootStore4$user === void 0 ? void 0 : _this$rootStore4$user.sessionDetails);

                this._processAppAttributes(this.rootStore.common.appAttributes);

                this._processUserProfile((_this$rootStore5 = this.rootStore) === null || _this$rootStore5 === void 0 ? void 0 : (_this$rootStore5$user = _this$rootStore5.user) === null || _this$rootStore5$user === void 0 ? void 0 : _this$rootStore5$user.isLoggedIn, (_this$rootStore6 = this.rootStore) === null || _this$rootStore6 === void 0 ? void 0 : (_this$rootStore6$user = _this$rootStore6.user) === null || _this$rootStore6$user === void 0 ? void 0 : _this$rootStore6$user.userProfile);

                this._isReservationFormDirty = false;

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "refresh",
    value: function () {
      var _refresh = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      function refresh() {
        return _refresh.apply(this, arguments);
      }

      return refresh;
    }()
  }, {
    key: "reset",
    value: function () {
      var _reset = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));

      function reset() {
        return _reset.apply(this, arguments);
      }

      return reset;
    }()
  }, {
    key: "getAllReservationRestaurants",
    value: function () {
      var _getAllReservationRestaurants = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(restaurantNumber) {
        var _this4 = this;

        var locationsList, _err$errors, _err$errors$, _err$errors2, _err$errors2$;

        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.prev = 0;
                _context9.next = 3;
                return dpservices.Reservation.getReservationRestaurants();

              case 3:
                locationsList = _context9.sent;

                if (locationsList && (locationsList === null || locationsList === void 0 ? void 0 : locationsList.length) > 0) {
                  this.reservationModel.locationsList = locationsList;
                  this.prepareReservationLocation(locationsList, restaurantNumber);
                }

                _context9.next = 11;
                break;

              case 7:
                _context9.prev = 7;
                _context9.t0 = _context9["catch"](0);

                if (_context9.t0 instanceof dpservices.Errors.UIError) {
                  this.analyticsModel.dispatchReservationErrorEvent(_context9.t0 === null || _context9.t0 === void 0 ? void 0 : (_err$errors = _context9.t0.errors) === null || _err$errors === void 0 ? void 0 : (_err$errors$ = _err$errors[0]) === null || _err$errors$ === void 0 ? void 0 : _err$errors$.code, _context9.t0 === null || _context9.t0 === void 0 ? void 0 : (_err$errors2 = _context9.t0.errors) === null || _err$errors2 === void 0 ? void 0 : (_err$errors2$ = _err$errors2[0]) === null || _err$errors2$ === void 0 ? void 0 : _err$errors2$.message);
                }

                this.rootStore.appMessages.showError("", "Unable to fetch restaurants.", null, {
                  undismissible: true,
                  okBtnText: "OK",
                  okBtnOnClick: function okBtnOnClick() {
                    _this4.rootStore.platformUtil.navigateToRoute("/home");
                  }
                });

              case 11:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this, [[0, 7]]);
      }));

      function getAllReservationRestaurants(_x6) {
        return _getAllReservationRestaurants.apply(this, arguments);
      }

      return getAllReservationRestaurants;
    }()
  }, {
    key: "restNumFromSession",
    value: function restNumFromSession() {
      var _this$_sessionDetails, _this$_sessionDetails2, _this$rootStore7, _this$rootStore7$user, _this$rootStore7$user2, _this$rootStore7$user3;

      return ((_this$_sessionDetails = this._sessionDetails) === null || _this$_sessionDetails === void 0 ? void 0 : (_this$_sessionDetails2 = _this$_sessionDetails.restaurantDetails) === null || _this$_sessionDetails2 === void 0 ? void 0 : _this$_sessionDetails2.restaurantNumber) || ((_this$rootStore7 = this.rootStore) === null || _this$rootStore7 === void 0 ? void 0 : (_this$rootStore7$user = _this$rootStore7.user) === null || _this$rootStore7$user === void 0 ? void 0 : (_this$rootStore7$user2 = _this$rootStore7$user.sessionDetails) === null || _this$rootStore7$user2 === void 0 ? void 0 : (_this$rootStore7$user3 = _this$rootStore7$user2.restaurantDetails) === null || _this$rootStore7$user3 === void 0 ? void 0 : _this$rootStore7$user3.restaurantNumber);
    }
  }, {
    key: "handleBackToMyReservations",
    value: function handleBackToMyReservations() {
      var _this$rootStore8, _this$rootStore8$plat, _this$reservationMode3;

      var platform = this === null || this === void 0 ? void 0 : (_this$rootStore8 = this.rootStore) === null || _this$rootStore8 === void 0 ? void 0 : (_this$rootStore8$plat = _this$rootStore8.platformUtil) === null || _this$rootStore8$plat === void 0 ? void 0 : _this$rootStore8$plat.PLATFORM_TYPE;
      var platformIsMobileApp = platform === PlatformType.APP ? true : false;
      this.isEditReservation = false;
      (_this$reservationMode3 = this.reservationModel) === null || _this$reservationMode3 === void 0 ? void 0 : _this$reservationMode3.reset();
      this.validateDefaultValues();

      this._processUserProfile(this.rootStore.user.isLoggedIn, this.rootStore.user.userProfile);

      this.reservationModel.tabReserveTable = false;

      if (platformIsMobileApp) {
        this.navigateToReservations([{
          name: "tabIndex",
          value: 1
        }]);
      } else {
        var _this$rootStore9, _this$rootStore9$plat;

        (_this$rootStore9 = this.rootStore) === null || _this$rootStore9 === void 0 ? void 0 : (_this$rootStore9$plat = _this$rootStore9.platformUtil) === null || _this$rootStore9$plat === void 0 ? void 0 : _this$rootStore9$plat.navigateToRoute("/reservations");
      }
    }
  }, {
    key: "_processUserProfile",
    value: function _processUserProfile(isLoggedIn, userProfile) {
      if (isLoggedIn && userProfile) {
        var _userProfile$defaultP;

        var defaultPhoneNumber = (_userProfile$defaultP = userProfile.defaultPhone) === null || _userProfile$defaultP === void 0 ? void 0 : _userProfile$defaultP.phoneNumber;
        this.reservationModel.firstName = userProfile.firstName;
        this.reservationModel.lastName = userProfile.lastName;
        this.reservationModel.phoneNumber = formatPhoneNumber(defaultPhoneNumber);
        this.reservationModel.email = userProfile.login;
      }
    } // TODO(RES): validate after API fix and remove if not required

  }, {
    key: "validateDefaultValues",
    value: function validateDefaultValues() {
      this.reservationModel.noOfGuests = "2";
    }
  }, {
    key: "getRestaurantTimeslots",
    value: function () {
      var _getRestaurantTimeslots = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
        var reset,
            _this$reservationMode4,
            _this$reservationMode5,
            _this$reservationMode6,
            requestDate,
            restNum,
            params,
            restTimeslots,
            slots,
            _err$errors3,
            _err$errors3$,
            _err$errors4,
            _err$errors4$,
            _err$errors5,
            _err$errors5$,
            _args10 = arguments;

        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                reset = _args10.length > 0 && _args10[0] !== undefined ? _args10[0] : true;
                _context10.prev = 1;
                requestDate = moment(this.reservationModel.reservationDateinTimestamp).format("L");
                restNum = (_this$reservationMode4 = this.reservationModel) === null || _this$reservationMode4 === void 0 ? void 0 : (_this$reservationMode5 = _this$reservationMode4.restDetails) === null || _this$reservationMode5 === void 0 ? void 0 : (_this$reservationMode6 = _this$reservationMode5.restaurantNumber) === null || _this$reservationMode6 === void 0 ? void 0 : _this$reservationMode6.toString();
                params = {
                  restaurantNum: restNum,
                  requestDate: requestDate
                };
                _context10.next = 7;
                return dpservices.Reservation.getRestaurantTimeslots(params);

              case 7:
                restTimeslots = _context10.sent;
                this.reservationModel.restTimeSlotsResp = restTimeslots;

                if (reset) {
                  slots = this.reservationModel.availableSlots;

                  if ((slots === null || slots === void 0 ? void 0 : slots.length) === 0) {
                    this.reservationModel.preferredTime = "No Slots";
                  } else {
                    // TODO(RES): replace 6.30 with app attributes after configured
                    if (moment("6:30 PM", "hh:mm A").isBetween(moment(slots === null || slots === void 0 ? void 0 : slots[0], "hh:mm A"), moment(slots === null || slots === void 0 ? void 0 : slots[(slots === null || slots === void 0 ? void 0 : slots.length) - 1], "hh:mm A"), null, "[]")) {
                      this.reservationModel.preferredTime = "6:30 PM";
                    } else {
                      this.reservationModel.preferredTime = slots === null || slots === void 0 ? void 0 : slots[0];
                    }
                  }
                }

                return _context10.abrupt("return", true);

              case 13:
                _context10.prev = 13;
                _context10.t0 = _context10["catch"](1); // required to null the stale data when error comes

                this.reservationModel.restTimeSlotsResp = null;
                this.reservationModel.preferredTime = "No Slots";

                if (!(_context10.t0 instanceof dpservices.Errors.UIError)) {
                  _context10.next = 21;
                  break;
                }

                this.analyticsModel.dispatchReservationErrorEvent(_context10.t0 === null || _context10.t0 === void 0 ? void 0 : (_err$errors3 = _context10.t0.errors) === null || _err$errors3 === void 0 ? void 0 : (_err$errors3$ = _err$errors3[0]) === null || _err$errors3$ === void 0 ? void 0 : _err$errors3$.code, _context10.t0 === null || _context10.t0 === void 0 ? void 0 : (_err$errors4 = _context10.t0.errors) === null || _err$errors4 === void 0 ? void 0 : (_err$errors4$ = _err$errors4[0]) === null || _err$errors4$ === void 0 ? void 0 : _err$errors4$.message);
                this.reservationModel.restAvailableSlotsError = _context10.t0 === null || _context10.t0 === void 0 ? void 0 : (_err$errors5 = _context10.t0.errors) === null || _err$errors5 === void 0 ? void 0 : (_err$errors5$ = _err$errors5[0]) === null || _err$errors5$ === void 0 ? void 0 : _err$errors5$.message;
                return _context10.abrupt("return", false);

              case 21:
                this.rootStore.appMessages.showError("", (_context10.t0 === null || _context10.t0 === void 0 ? void 0 : _context10.t0.message) || "Unable to find time slots for this location.");
                return _context10.abrupt("return", false);

              case 23:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this, [[1, 13]]);
      }));

      function getRestaurantTimeslots() {
        return _getRestaurantTimeslots.apply(this, arguments);
      }

      return getRestaurantTimeslots;
    }()
  }, {
    key: "getRestaurantAvailableSlots",
    value: function () {
      var _getRestaurantAvailableSlots = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
        var _this5 = this;

        var reset,
            _this$reservationMode7,
            _this$reservationMode8,
            _this$reservationMode9,
            _this$getRestaurantPh,
            _this$reservationMode10,
            _this$reservationMode11,
            requestDate,
            restPhoneDetail,
            restPhoneNumber,
            _this$reservationMode12,
            _this$reservationMode13,
            _this$reservationMode14,
            restNum,
            params,
            restAvailableslots,
            _restAvailableslots$f,
            _restAvailableslots$f2,
            reqTimeSlot,
            _reqTimeSlot$,
            _reqTimeSlot$2,
            _reqTimeSlot$3,
            _err$errors6,
            _err$errors6$,
            _err$errors7,
            _err$errors7$,
            _err$errors8,
            _err$errors8$,
            _args11 = arguments;

        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                reset = _args11.length > 0 && _args11[0] !== undefined ? _args11[0] : true;
                _context11.prev = 1;

                if (reset) {
                  this.reservationModel.restAvailableSlotsError = "";
                  this.reservationModel.seatingOptions = [];
                  this.reservationModel.selectedSeatingOption = "";
                  this.reservationModel.reservationTime = "";
                  this.reservationModel.restAvailableSlotsResp = [];
                }

                requestDate = moment(this.reservationModel.reservationDateinTimestamp).format("L");
                restPhoneDetail = (_this$reservationMode7 = this.reservationModel) === null || _this$reservationMode7 === void 0 ? void 0 : (_this$reservationMode8 = _this$reservationMode7.restDetails) === null || _this$reservationMode8 === void 0 ? void 0 : (_this$reservationMode9 = _this$reservationMode8.contactDetail) === null || _this$reservationMode9 === void 0 ? void 0 : _this$reservationMode9.phoneDetail;
                restPhoneNumber = this === null || this === void 0 ? void 0 : (_this$getRestaurantPh = this.getRestaurantPhoneNumberByType(restPhoneDetail, "Primary")) === null || _this$getRestaurantPh === void 0 ? void 0 : _this$getRestaurantPh.phoneNumber;

                if (!(this.reservationModel.noOfGuests && ((_this$reservationMode10 = this.reservationModel) === null || _this$reservationMode10 === void 0 ? void 0 : (_this$reservationMode11 = _this$reservationMode10.availableSlots) === null || _this$reservationMode11 === void 0 ? void 0 : _this$reservationMode11.length) > 0)) {
                  _context11.next = 30;
                  break;
                }

                restNum = (_this$reservationMode12 = this.reservationModel) === null || _this$reservationMode12 === void 0 ? void 0 : (_this$reservationMode13 = _this$reservationMode12.restDetails) === null || _this$reservationMode13 === void 0 ? void 0 : (_this$reservationMode14 = _this$reservationMode13.restaurantNumber) === null || _this$reservationMode14 === void 0 ? void 0 : _this$reservationMode14.toString();
                params = {
                  restaurantNum: restNum,
                  reservationDate: requestDate,
                  reservationTime: this.reservationModel.preferredTime,
                  partySize: this.reservationModel.noOfGuests
                };
                this.reservationModel.isRestAvailableSlotsLoading = true;
                _context11.next = 12;
                return dpservices.Reservation.getRestaurantAvailableslots(params);

              case 12:
                restAvailableslots = _context11.sent;

                if (!((restAvailableslots === null || restAvailableslots === void 0 ? void 0 : restAvailableslots.length) > 0)) {
                  _context11.next = 27;
                  break;
                }

                this.reservationModel.restAvailableSlotsResp = restAvailableslots;
                this.reservationModel.errObj = null;
                this.reservationModel.currentSelectedCTA = ReservationSelectedCTA.AVAILBALE_SLOTS;

                if (!reset) {
                  _context11.next = 22;
                  break;
                }

                reqTimeSlot = restAvailableslots === null || restAvailableslots === void 0 ? void 0 : restAvailableslots.filter(function (item) {
                  var _moment, _this5$reservationMod;

                  return ((_moment = moment(item === null || item === void 0 ? void 0 : item.time, "HH:mm:ss")) === null || _moment === void 0 ? void 0 : _moment.format("h:mm A")) === ((_this5$reservationMod = _this5.reservationModel) === null || _this5$reservationMod === void 0 ? void 0 : _this5$reservationMod.preferredTime);
                }); //if preferred time is available in available slots then we select that otherwise we let the user choose

                if ((reqTimeSlot === null || reqTimeSlot === void 0 ? void 0 : reqTimeSlot.length) === 1) {
                  this.reservationModel.reservationTime = reqTimeSlot === null || reqTimeSlot === void 0 ? void 0 : (_reqTimeSlot$ = reqTimeSlot[0]) === null || _reqTimeSlot$ === void 0 ? void 0 : _reqTimeSlot$.time;
                  this.reservationModel.seatingOptions = reqTimeSlot === null || reqTimeSlot === void 0 ? void 0 : (_reqTimeSlot$2 = reqTimeSlot[0]) === null || _reqTimeSlot$2 === void 0 ? void 0 : _reqTimeSlot$2.seatingTypes; // if seating options are other than STANDARD or DEFAULT do not make default selection

                  this.reservationModel.selectedSeatingOption = this.getSeatingOptionForDefault(reqTimeSlot === null || reqTimeSlot === void 0 ? void 0 : (_reqTimeSlot$3 = reqTimeSlot[0]) === null || _reqTimeSlot$3 === void 0 ? void 0 : _reqTimeSlot$3.seatingTypes);
                }

                this.reservationModel.isRestAvailableSlotsLoading = false;
                return _context11.abrupt("return", true);

              case 22:
                this.reservationModel.seatingOptions = (restAvailableslots === null || restAvailableslots === void 0 ? void 0 : (_restAvailableslots$f = restAvailableslots.filter(function (slots) {
                  var _this5$reservationMod2;

                  return (slots === null || slots === void 0 ? void 0 : slots.time) === ((_this5$reservationMod2 = _this5.reservationModel) === null || _this5$reservationMod2 === void 0 ? void 0 : _this5$reservationMod2.reservationTime);
                })) === null || _restAvailableslots$f === void 0 ? void 0 : (_restAvailableslots$f2 = _restAvailableslots$f[0]) === null || _restAvailableslots$f2 === void 0 ? void 0 : _restAvailableslots$f2.seatingTypes) || [];
                this.reservationModel.isRestAvailableSlotsLoading = false;
                return _context11.abrupt("return", true);

              case 27:
                this.reservationModel.restAvailableSlotsError = i18next.t("reservation_text_no.available.timeslots", {
                  defaultValue: "We\u2019re sorry, but there is no reservation time available for your selected date and number of guests. For further assistance, please contact the restaurant directly at ".concat(restPhoneNumber, "."),
                  interpolation: {
                    prefix: "${",
                    suffix: "}"
                  },
                  0: restPhoneNumber
                });

              case 28:
                _context11.next = 31;
                break;

              case 30:
                this.reservationModel.restAvailableSlotsError = this.reservationModel.restAvailableSlotsError = i18next.t("reservation_text_no.available.timeslots", {
                  defaultValue: "We\u2019re sorry, but there is no reservation time available for your selected date and number of guests. For further assistance, please contact the restaurant directly at ".concat(restPhoneNumber, "."),
                  interpolation: {
                    prefix: "${",
                    suffix: "}"
                  },
                  0: restPhoneNumber
                });

              case 31:
                this.reservationModel.isRestAvailableSlotsLoading = false;
                return _context11.abrupt("return", false);

              case 35:
                _context11.prev = 35;
                _context11.t0 = _context11["catch"](1);
                this.reservationModel.isRestAvailableSlotsLoading = false;
                this.dispatchReservationTimeNotAvailableEvent(this.reservationModel.preferredTime);

                if (!(_context11.t0 instanceof dpservices.Errors.UIError)) {
                  _context11.next = 43;
                  break;
                }

                this.analyticsModel.dispatchReservationErrorEvent(_context11.t0 === null || _context11.t0 === void 0 ? void 0 : (_err$errors6 = _context11.t0.errors) === null || _err$errors6 === void 0 ? void 0 : (_err$errors6$ = _err$errors6[0]) === null || _err$errors6$ === void 0 ? void 0 : _err$errors6$.code, _context11.t0 === null || _context11.t0 === void 0 ? void 0 : (_err$errors7 = _context11.t0.errors) === null || _err$errors7 === void 0 ? void 0 : (_err$errors7$ = _err$errors7[0]) === null || _err$errors7$ === void 0 ? void 0 : _err$errors7$.message);
                this.reservationModel.restAvailableSlotsError = _context11.t0 === null || _context11.t0 === void 0 ? void 0 : (_err$errors8 = _context11.t0.errors) === null || _err$errors8 === void 0 ? void 0 : (_err$errors8$ = _err$errors8[0]) === null || _err$errors8$ === void 0 ? void 0 : _err$errors8$.message;
                return _context11.abrupt("return", false);

              case 43:
                this.rootStore.appMessages.showError("", (_context11.t0 === null || _context11.t0 === void 0 ? void 0 : _context11.t0.message) || "Unable to find available slots for this location.");
                return _context11.abrupt("return", false);

              case 45:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this, [[1, 35]]);
      }));

      function getRestaurantAvailableSlots() {
        return _getRestaurantAvailableSlots.apply(this, arguments);
      }

      return getRestaurantAvailableSlots;
    }()
  }, {
    key: "createReservation",
    value: function () {
      var _createReservation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
        var _this6 = this;

        var _this$rootStore10, _this$rootStore10$pla, _this$reservationMode15, _this$reservationMode16, _this$reservationMode17, _this$reservationMode18, _this$reservationMode19, _this$reservationMode20, _this$reservationMode21, _this$reservationMode22, _this$reservationMode23, _this$reservationMode24, _this$reservationMode25, _this$reservationMode26, platform, platformIsMobileApp, requestDate, requestTime, conceptCode, signUpSrc, reqBodyObj, _this$rootStore11, _this$rootStore11$use, _this$rootStore12, _this$rootStore12$use, _this$reservationMode27, confirmationNumber, _this$rootStore13, _this$rootStore13$pla, _this$reservationMode28, _this$reservationMode29, _this$reservationMode30, _this$reservationMode31, _moment2, _this$reservationMode32, _err$errors9, _err$errors9$, isHourError, title, _err$errors10, _err$errors10$, _err$errors11, _err$errors11$, _err$errors12, _err$errors12$;

        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.prev = 0;
                platform = this === null || this === void 0 ? void 0 : (_this$rootStore10 = this.rootStore) === null || _this$rootStore10 === void 0 ? void 0 : (_this$rootStore10$pla = _this$rootStore10.platformUtil) === null || _this$rootStore10$pla === void 0 ? void 0 : _this$rootStore10$pla.PLATFORM_TYPE;
                platformIsMobileApp = platform === PlatformType.APP ? true : false;
                requestDate = moment(this.reservationModel.reservationDateinTimestamp).format("L");
                requestTime = moment(this.reservationModel.reservationTime, "hh:mm:s").format("hh:mm A");
                conceptCode = this._appAttributes.currentConceptCode;
                signUpSrc = platformIsMobileApp ? i18next.t("reservation.signup_source_app", {
                  defaultValue: "".concat(conceptCode.toLowerCase(), "_mapp_reservation")
                }) : i18next.t("reservation.signup_source", {
                  defaultValue: "".concat(conceptCode.toLowerCase(), "_signup_reservation")
                });
                reqBodyObj = {
                  reservationInfo: {
                    restaurantNum: (_this$reservationMode15 = this.reservationModel) === null || _this$reservationMode15 === void 0 ? void 0 : (_this$reservationMode16 = _this$reservationMode15.restDetails) === null || _this$reservationMode16 === void 0 ? void 0 : (_this$reservationMode17 = _this$reservationMode16.restaurantNumber) === null || _this$reservationMode17 === void 0 ? void 0 : _this$reservationMode17.toString(),
                    eclubOptin: (_this$reservationMode18 = this.reservationModel) === null || _this$reservationMode18 === void 0 ? void 0 : _this$reservationMode18.eclubOption,
                    subscription: {
                      type: "subscription",
                      preferenceName: conceptCode.toUpperCase(),
                      subscriptionStatus: "P",
                      secondarySubscriptions: (_this$reservationMode19 = this.reservationModel) === null || _this$reservationMode19 === void 0 ? void 0 : _this$reservationMode19.secondarySubscriptions,
                      signupSource: signUpSrc
                    },
                    userDetail: {
                      firstName: (_this$reservationMode20 = this.reservationModel) === null || _this$reservationMode20 === void 0 ? void 0 : _this$reservationMode20.firstName,
                      lastName: (_this$reservationMode21 = this.reservationModel) === null || _this$reservationMode21 === void 0 ? void 0 : _this$reservationMode21.lastName,
                      dob: ((_this$reservationMode22 = this.reservationModel) === null || _this$reservationMode22 === void 0 ? void 0 : _this$reservationMode22.dob) || "",
                      phone: this.reservationModel.phoneNumber,
                      email: this.reservationModel.email
                    },
                    timeSlot: {
                      reservationDate: requestDate,
                      reservationTime: requestTime
                    },
                    partySize: Number((_this$reservationMode23 = this.reservationModel) === null || _this$reservationMode23 === void 0 ? void 0 : _this$reservationMode23.noOfGuests),
                    eventInfo: {
                      specialRequests: (_this$reservationMode24 = this.reservationModel) !== null && _this$reservationMode24 !== void 0 && _this$reservationMode24.showSpecialRequests ? (_this$reservationMode25 = this.reservationModel) === null || _this$reservationMode25 === void 0 ? void 0 : _this$reservationMode25.specialRequestsText : "",
                      isFirstTime: this.reservationModel.isFirstTime,
                      isFirstTimeAtLocation: this.reservationModel.isFirstTimeAtLocation,
                      isBusiness: this.reservationModel.reservationTypeIsBusiness
                    },
                    seatingType: (_this$reservationMode26 = this.reservationModel) === null || _this$reservationMode26 === void 0 ? void 0 : _this$reservationMode26.selectedSeatingOption
                  }
                };
                this.dispatchReservationFormStartEvent();

                if (!this.reservationModel.isModelValid) {
                  _context12.next = 31;
                  break;
                }

                if ((_this$rootStore11 = this.rootStore) !== null && _this$rootStore11 !== void 0 && (_this$rootStore11$use = _this$rootStore11.user) !== null && _this$rootStore11$use !== void 0 && _this$rootStore11$use.isLoggedIn) {
                  _context12.next = 13;
                  break;
                }

                _context12.next = 13;
                return this.rootStore.platformUtil.saveInLocalStorage("RESERVATION_EMAIL", this.reservationModel.email);

              case 13:
                this.reservationModel.isReservationLoading = true;
                _context12.next = 16;
                return dpservices.Reservation.createReservation(reqBodyObj);

              case 16:
                confirmationNumber = _context12.sent;
                this.reservationModel.confirmationNumber = confirmationNumber;

                if ((_this$rootStore12 = this.rootStore) !== null && _this$rootStore12 !== void 0 && (_this$rootStore12$use = _this$rootStore12.user) !== null && _this$rootStore12$use !== void 0 && _this$rootStore12$use.isLoggedIn) {
                  this.getReservations(false);
                }

                if ((_this$reservationMode27 = this.reservationModel) !== null && _this$reservationMode27 !== void 0 && _this$reservationMode27.eclubOption) {
                  (_this$rootStore13 = this.rootStore) === null || _this$rootStore13 === void 0 ? void 0 : (_this$rootStore13$pla = _this$rootStore13.platformUtil) === null || _this$rootStore13$pla === void 0 ? void 0 : _this$rootStore13$pla.dispatchEvent("AnalyticsForm", "eClubOptinComplete", {
                    brands: (_this$reservationMode28 = this.reservationModel) === null || _this$reservationMode28 === void 0 ? void 0 : _this$reservationMode28.secondarySubscriptions,
                    signupChannel: signUpSrc
                  });
                }

                this.dispatchReservationSubmitEvent();
                this.dispatchReservationFormSubmitEvent();

                if (!(confirmationNumber && (confirmationNumber === null || confirmationNumber === void 0 ? void 0 : confirmationNumber.length) >= 0)) {
                  _context12.next = 29;
                  break;
                }

                this.dispatchReservationCompleteEvent();
                this.analyticsModel.dispatchReservations("", (_this$reservationMode29 = this.reservationModel) === null || _this$reservationMode29 === void 0 ? void 0 : (_this$reservationMode30 = _this$reservationMode29.restDetails) === null || _this$reservationMode30 === void 0 ? void 0 : _this$reservationMode30.atgRestaurantId, requestTime, (_this$reservationMode31 = this.reservationModel) === null || _this$reservationMode31 === void 0 ? void 0 : _this$reservationMode31.noOfGuests, "", requestDate, ((_moment2 = moment(requestDate, "MM/DD/YYYY")) === null || _moment2 === void 0 ? void 0 : _moment2.day()) + "", (_this$reservationMode32 = this.reservationModel) !== null && _this$reservationMode32 !== void 0 && _this$reservationMode32.reservationTypeIsBusiness ? "business" : "casual");
                this.reservationModel.isReservationLoading = false;
                return _context12.abrupt("return", true);

              case 29:
                this.reservationModel.isReservationLoading = false;
                this.rootStore.appMessages.showError("", "Unable to reserve your table at the moment.");

              case 31:
                return _context12.abrupt("return", false);

              case 34:
                _context12.prev = 34;
                _context12.t0 = _context12["catch"](0);
                this.reservationModel.isReservationLoading = false;
                isHourError = _context12.t0 !== null && _context12.t0 !== void 0 && (_err$errors9 = _context12.t0.errors) !== null && _err$errors9 !== void 0 && (_err$errors9$ = _err$errors9[0]) !== null && _err$errors9$ !== void 0 && _err$errors9$.message.includes("2.5") ? true : false;
                title = isHourError ? i18next.t("text.reservation.error_hourRestriction", {
                  defaultValue: "Unable to complete your request"
                }) : "Something went wrong";

                if (!(_context12.t0 instanceof dpservices.Errors.UIError)) {
                  _context12.next = 43;
                  break;
                }

                this.analyticsModel.dispatchReservationErrorEvent(_context12.t0 === null || _context12.t0 === void 0 ? void 0 : (_err$errors10 = _context12.t0.errors) === null || _err$errors10 === void 0 ? void 0 : (_err$errors10$ = _err$errors10[0]) === null || _err$errors10$ === void 0 ? void 0 : _err$errors10$.code, _context12.t0 === null || _context12.t0 === void 0 ? void 0 : (_err$errors11 = _context12.t0.errors) === null || _err$errors11 === void 0 ? void 0 : (_err$errors11$ = _err$errors11[0]) === null || _err$errors11$ === void 0 ? void 0 : _err$errors11$.message);
                this.rootStore.appMessages.showError(isHourError ? title : "", (_context12.t0 === null || _context12.t0 === void 0 ? void 0 : (_err$errors12 = _context12.t0.errors) === null || _err$errors12 === void 0 ? void 0 : (_err$errors12$ = _err$errors12[0]) === null || _err$errors12$ === void 0 ? void 0 : _err$errors12$.message) || "Unable to reserve your table at the moment", null, {
                  undismissible: true,
                  okBtnText: "Edit Reservation",
                  okBtnOnClick: function okBtnOnClick() {
                    _this6.rootStore.appMessages.showErrorDialog = false;
                  }
                });
                return _context12.abrupt("return", false);

              case 43:
                this.rootStore.appMessages.showError("", (_context12.t0 === null || _context12.t0 === void 0 ? void 0 : _context12.t0.message) || "Unable to reserve your table at the moment.");
                return _context12.abrupt("return", false);

              case 45:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this, [[0, 34]]);
      }));

      function createReservation() {
        return _createReservation.apply(this, arguments);
      }

      return createReservation;
    }()
  }, {
    key: "updateReservation",
    value: function () {
      var _updateReservation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
        var _this$rootStore14, _this$rootStore14$pla, _this$reservationMode33, _this$reservationMode34, _this$reservationMode35, _this$reservationMode36, _this$reservationMode37, _this$reservationMode38, _this$reservationMode39, _this$reservationMode40, _this$reservationMode41, _this$reservationMode42, _this$reservationMode43, _this$reservationMode44, _this$reservationMode45, platform, platformIsMobileApp, requestDate, requestTime, conceptCode, signUpSrc, reqBodyObj, _this$rootStore15, _this$rootStore15$use, confirmationNumber, _this$rootStore16, _this$rootStore16$use, _err$errors13, _err$errors13$, _err$errors14, _err$errors14$, _err$errors15, _err$errors15$;

        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.prev = 0;
                platform = this === null || this === void 0 ? void 0 : (_this$rootStore14 = this.rootStore) === null || _this$rootStore14 === void 0 ? void 0 : (_this$rootStore14$pla = _this$rootStore14.platformUtil) === null || _this$rootStore14$pla === void 0 ? void 0 : _this$rootStore14$pla.PLATFORM_TYPE;
                platformIsMobileApp = platform === PlatformType.APP ? true : false;
                requestDate = moment(this.reservationModel.reservationDateinTimestamp).format("L");
                requestTime = moment(this.reservationModel.reservationTime, "hh:mm:s").format("hh:mm A");
                conceptCode = this._appAttributes.currentConceptCode;
                signUpSrc = platformIsMobileApp ? i18next.t("reservation.signup_source_app", {
                  defaultValue: "".concat(conceptCode.toLowerCase(), "_mapp_reservation")
                }) : i18next.t("reservation.signup_source", {
                  defaultValue: "".concat(conceptCode.toLowerCase(), "_signup_reservation")
                });
                reqBodyObj = {
                  reservationInfo: {
                    confirmationNumber: (_this$reservationMode33 = this.reservationModel) === null || _this$reservationMode33 === void 0 ? void 0 : _this$reservationMode33.confirmationNumber,
                    restaurantNum: (_this$reservationMode34 = this.reservationModel) === null || _this$reservationMode34 === void 0 ? void 0 : (_this$reservationMode35 = _this$reservationMode34.restDetails) === null || _this$reservationMode35 === void 0 ? void 0 : (_this$reservationMode36 = _this$reservationMode35.restaurantNumber) === null || _this$reservationMode36 === void 0 ? void 0 : _this$reservationMode36.toString(),
                    eclubOptin: (_this$reservationMode37 = this.reservationModel) === null || _this$reservationMode37 === void 0 ? void 0 : _this$reservationMode37.eclubOption,
                    subscription: {
                      type: "subscription",
                      preferenceName: conceptCode.toUpperCase(),
                      subscriptionStatus: "P",
                      secondarySubscriptions: (_this$reservationMode38 = this.reservationModel) === null || _this$reservationMode38 === void 0 ? void 0 : _this$reservationMode38.secondarySubscriptions,
                      signupSource: signUpSrc
                    },
                    userDetail: {
                      firstName: (_this$reservationMode39 = this.reservationModel) === null || _this$reservationMode39 === void 0 ? void 0 : _this$reservationMode39.firstName,
                      lastName: (_this$reservationMode40 = this.reservationModel) === null || _this$reservationMode40 === void 0 ? void 0 : _this$reservationMode40.lastName,
                      dob: ((_this$reservationMode41 = this.reservationModel) === null || _this$reservationMode41 === void 0 ? void 0 : _this$reservationMode41.dob) || "",
                      phone: this.reservationModel.phoneNumber,
                      email: this.reservationModel.email
                    },
                    timeSlot: {
                      reservationDate: requestDate,
                      reservationTime: requestTime
                    },
                    partySize: Number((_this$reservationMode42 = this.reservationModel) === null || _this$reservationMode42 === void 0 ? void 0 : _this$reservationMode42.noOfGuests),
                    eventInfo: {
                      specialRequests: (_this$reservationMode43 = this.reservationModel) !== null && _this$reservationMode43 !== void 0 && _this$reservationMode43.showSpecialRequests ? (_this$reservationMode44 = this.reservationModel) === null || _this$reservationMode44 === void 0 ? void 0 : _this$reservationMode44.specialRequestsText : "",
                      isFirstTime: this.reservationModel.isFirstTime,
                      isFirstTimeAtLocation: this.reservationModel.isFirstTimeAtLocation,
                      isBusiness: this.reservationModel.reservationTypeIsBusiness
                    },
                    seatingType: (_this$reservationMode45 = this.reservationModel) === null || _this$reservationMode45 === void 0 ? void 0 : _this$reservationMode45.selectedSeatingOption
                  }
                };

                if (!this.reservationModel.isModelValid) {
                  _context13.next = 25;
                  break;
                }

                if ((_this$rootStore15 = this.rootStore) !== null && _this$rootStore15 !== void 0 && (_this$rootStore15$use = _this$rootStore15.user) !== null && _this$rootStore15$use !== void 0 && _this$rootStore15$use.isLoggedIn) {
                  _context13.next = 12;
                  break;
                }

                _context13.next = 12;
                return this.rootStore.platformUtil.saveInLocalStorage("RESERVATION_EMAIL", this.reservationModel.email);

              case 12:
                this.reservationModel.isReservationLoading = true;
                _context13.next = 15;
                return dpservices.Reservation.updateReservation(reqBodyObj);

              case 15:
                confirmationNumber = _context13.sent;
                this.reservationModel.isReservationLoading = false;

                if (!(confirmationNumber && (confirmationNumber === null || confirmationNumber === void 0 ? void 0 : confirmationNumber.length) >= 0)) {
                  _context13.next = 24;
                  break;
                }

                this.reservationModel.confirmationNumber = confirmationNumber;

                if ((_this$rootStore16 = this.rootStore) !== null && _this$rootStore16 !== void 0 && (_this$rootStore16$use = _this$rootStore16.user) !== null && _this$rootStore16$use !== void 0 && _this$rootStore16$use.isLoggedIn) {
                  this.getReservations(false);
                }

                this.dispatchEditReservationConfirmationEvent();
                return _context13.abrupt("return", true);

              case 24:
                this.rootStore.appMessages.showError("", "Unable to reserve your table at the moment.");

              case 25:
                return _context13.abrupt("return", false);

              case 28:
                _context13.prev = 28;
                _context13.t0 = _context13["catch"](0);
                console.warn("err", _context13.t0);
                this.reservationModel.isReservationLoading = false;

                if (!(_context13.t0 instanceof dpservices.Errors.UIError)) {
                  _context13.next = 36;
                  break;
                }

                this.analyticsModel.dispatchReservationErrorEvent(_context13.t0 === null || _context13.t0 === void 0 ? void 0 : (_err$errors13 = _context13.t0.errors) === null || _err$errors13 === void 0 ? void 0 : (_err$errors13$ = _err$errors13[0]) === null || _err$errors13$ === void 0 ? void 0 : _err$errors13$.code, _context13.t0 === null || _context13.t0 === void 0 ? void 0 : (_err$errors14 = _context13.t0.errors) === null || _err$errors14 === void 0 ? void 0 : (_err$errors14$ = _err$errors14[0]) === null || _err$errors14$ === void 0 ? void 0 : _err$errors14$.message);
                this.rootStore.appMessages.showError("", _context13.t0 === null || _context13.t0 === void 0 ? void 0 : (_err$errors15 = _context13.t0.errors) === null || _err$errors15 === void 0 ? void 0 : (_err$errors15$ = _err$errors15[0]) === null || _err$errors15$ === void 0 ? void 0 : _err$errors15$.message);
                return _context13.abrupt("return", false);

              case 36:
                this.rootStore.appMessages.showError("", (_context13.t0 === null || _context13.t0 === void 0 ? void 0 : _context13.t0.message) || "Unable to update your reservation at the moment");
                return _context13.abrupt("return", false);

              case 38:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this, [[0, 28]]);
      }));

      function updateReservation() {
        return _updateReservation.apply(this, arguments);
      }

      return updateReservation;
    }()
  }, {
    key: "sendNotification",
    value: function () {
      var _sendNotification = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14() {
        var reqBody, resp, _err$errors16, _err$errors16$, _err$errors17, _err$errors17$, _err$errors18, _err$errors18$;

        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.prev = 0;
                this.reservationModel.lookupReservationErrorResp = "";
                reqBody = {
                  guestEmailAddresses: this.reservationModel.reviewReservationsEmail,
                  notificationType: "email"
                };
                _context14.next = 5;
                return dpservices.Reservation.createNotification(reqBody);

              case 5:
                resp = _context14.sent;
                this.reservationModel.reviewReservationsEmail = "";

                if (!resp) {
                  _context14.next = 9;
                  break;
                }

                return _context14.abrupt("return", true);

              case 9:
                return _context14.abrupt("return", false);

              case 12:
                _context14.prev = 12;
                _context14.t0 = _context14["catch"](0);
                this.reservationModel.reviewReservationsEmail = "";

                if (!(_context14.t0 instanceof dpservices.Errors.UIError)) {
                  _context14.next = 19;
                  break;
                }

                this.analyticsModel.dispatchReservationErrorEvent(_context14.t0 === null || _context14.t0 === void 0 ? void 0 : (_err$errors16 = _context14.t0.errors) === null || _err$errors16 === void 0 ? void 0 : (_err$errors16$ = _err$errors16[0]) === null || _err$errors16$ === void 0 ? void 0 : _err$errors16$.code, _context14.t0 === null || _context14.t0 === void 0 ? void 0 : (_err$errors17 = _context14.t0.errors) === null || _err$errors17 === void 0 ? void 0 : (_err$errors17$ = _err$errors17[0]) === null || _err$errors17$ === void 0 ? void 0 : _err$errors17$.message);
                this.reservationModel.lookupReservationErrorResp = (_context14.t0 === null || _context14.t0 === void 0 ? void 0 : (_err$errors18 = _context14.t0.errors) === null || _err$errors18 === void 0 ? void 0 : (_err$errors18$ = _err$errors18[0]) === null || _err$errors18$ === void 0 ? void 0 : _err$errors18$.message) || "Unable to look up your reservation at the moment.";
                return _context14.abrupt("return", true);

              case 19:
                this.rootStore.appMessages.showError("", (_context14.t0 === null || _context14.t0 === void 0 ? void 0 : _context14.t0.message) || "Unable to look up your reservation at the moment.");
                return _context14.abrupt("return", false);

              case 21:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this, [[0, 12]]);
      }));

      function sendNotification() {
        return _sendNotification.apply(this, arguments);
      }

      return sendNotification;
    }()
  }, {
    key: "cancelReservation",
    value: function () {
      var _cancelReservation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15() {
        var _this$rootStore17,
            _this$rootStore17$pla,
            _this7 = this;

        var redirectToUrl,
            reloadPage,
            platform,
            platformIsMobileApp,
            _this$reservationMode46,
            reqBodyObj,
            resp,
            _this$rootStore18,
            _this$rootStore18$use,
            _this$rootStore19,
            _this$rootStore19$use,
            _this$rootStore20,
            _this$rootStore20$use,
            _err$errors19,
            _err$errors19$,
            _err$errors20,
            _err$errors20$,
            _err$errors21,
            _err$errors21$,
            _args15 = arguments;

        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                redirectToUrl = _args15.length > 0 && _args15[0] !== undefined ? _args15[0] : true;
                reloadPage = _args15.length > 1 && _args15[1] !== undefined ? _args15[1] : false;
                platform = this === null || this === void 0 ? void 0 : (_this$rootStore17 = this.rootStore) === null || _this$rootStore17 === void 0 ? void 0 : (_this$rootStore17$pla = _this$rootStore17.platformUtil) === null || _this$rootStore17$pla === void 0 ? void 0 : _this$rootStore17$pla.PLATFORM_TYPE;
                platformIsMobileApp = platform === PlatformType.APP ? true : false;
                _context15.prev = 4;
                reqBodyObj = {
                  confirmationNumber: (_this$reservationMode46 = this.reservationModel) === null || _this$reservationMode46 === void 0 ? void 0 : _this$reservationMode46.confirmationNumber
                };
                _context15.next = 8;
                return dpservices.Reservation.deleteReservation(reqBodyObj);

              case 8:
                resp = _context15.sent;

                if (!resp) {
                  _context15.next = 15;
                  break;
                }

                if ((_this$rootStore18 = this.rootStore) !== null && _this$rootStore18 !== void 0 && (_this$rootStore18$use = _this$rootStore18.user) !== null && _this$rootStore18$use !== void 0 && _this$rootStore18$use.isLoggedIn) {
                  this.getReservations(false);
                }

                this.dispatchReservationCancelEvent();

                this._processUserProfile((_this$rootStore19 = this.rootStore) === null || _this$rootStore19 === void 0 ? void 0 : (_this$rootStore19$use = _this$rootStore19.user) === null || _this$rootStore19$use === void 0 ? void 0 : _this$rootStore19$use.isLoggedIn, (_this$rootStore20 = this.rootStore) === null || _this$rootStore20 === void 0 ? void 0 : (_this$rootStore20$use = _this$rootStore20.user) === null || _this$rootStore20$use === void 0 ? void 0 : _this$rootStore20$use.userProfile);

                this.reservationModel.showReservationCancelSuccessModal = {
                  showModal: true,
                  redirect: redirectToUrl,
                  reload: reloadPage
                };
                return _context15.abrupt("return", true);

              case 15:
                return _context15.abrupt("return", false);

              case 18:
                _context15.prev = 18;
                _context15.t0 = _context15["catch"](4);
                console.warn("err", _context15.t0 === null || _context15.t0 === void 0 ? void 0 : _context15.t0.message);

                if (!(_context15.t0 instanceof dpservices.Errors.UIError)) {
                  _context15.next = 25;
                  break;
                }

                this.analyticsModel.dispatchReservationErrorEvent(_context15.t0 === null || _context15.t0 === void 0 ? void 0 : (_err$errors19 = _context15.t0.errors) === null || _err$errors19 === void 0 ? void 0 : (_err$errors19$ = _err$errors19[0]) === null || _err$errors19$ === void 0 ? void 0 : _err$errors19$.code, _context15.t0 === null || _context15.t0 === void 0 ? void 0 : (_err$errors20 = _context15.t0.errors) === null || _err$errors20 === void 0 ? void 0 : (_err$errors20$ = _err$errors20[0]) === null || _err$errors20$ === void 0 ? void 0 : _err$errors20$.message);
                this.rootStore.appMessages.showError("", _context15.t0 === null || _context15.t0 === void 0 ? void 0 : (_err$errors21 = _context15.t0.errors) === null || _err$errors21 === void 0 ? void 0 : (_err$errors21$ = _err$errors21[0]) === null || _err$errors21$ === void 0 ? void 0 : _err$errors21$.message, null, {
                  undismissible: true,
                  okBtnText: "OK",
                  okBtnOnClick: function okBtnOnClick() {
                    if (platformIsMobileApp) {
                      _this7.rootStore.platformUtil.navigateToRoute("/home");
                    } else {
                      _this7.rootStore.platformUtil.goToURL("/reservations");
                    }
                  }
                });
                return _context15.abrupt("return", false);

              case 25:
                this.rootStore.appMessages.showError("", (_context15.t0 === null || _context15.t0 === void 0 ? void 0 : _context15.t0.message) || "Unable to cancel your reservation at the moment.", null, {
                  undismissible: true,
                  okBtnText: "OK",
                  okBtnOnClick: function okBtnOnClick() {
                    if (platformIsMobileApp) {
                      _this7.rootStore.platformUtil.navigateToRoute("/home");
                    } else {
                      _this7.rootStore.platformUtil.goToURL("/reservations");
                    }
                  }
                });
                return _context15.abrupt("return", false);

              case 27:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this, [[4, 18]]);
      }));

      function cancelReservation() {
        return _cancelReservation.apply(this, arguments);
      }

      return cancelReservation;
    }()
  }, {
    key: "handleReservationCancellationSuccessConfirm",
    value: function () {
      var _handleReservationCancellationSuccessConfirm = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16() {
        var _this$reservationMode47, _this$reservationMode48, _this$reservationMode49, _this$reservationMode50, _this$rootStore21, _this$rootStore21$pla;

        var redirect, reload, platform, platformIsMobileApp, _this$reservationMode51, notificationId, _this$rootStore22, _this$rootStore22$pla, _this$rootStore23, _this$rootStore24, _this$rootStore25;

        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                redirect = (_this$reservationMode47 = this.reservationModel) === null || _this$reservationMode47 === void 0 ? void 0 : (_this$reservationMode48 = _this$reservationMode47.showReservationCancelSuccessModal) === null || _this$reservationMode48 === void 0 ? void 0 : _this$reservationMode48.redirect;
                reload = (_this$reservationMode49 = this.reservationModel) === null || _this$reservationMode49 === void 0 ? void 0 : (_this$reservationMode50 = _this$reservationMode49.showReservationCancelSuccessModal) === null || _this$reservationMode50 === void 0 ? void 0 : _this$reservationMode50.reload;
                platform = this === null || this === void 0 ? void 0 : (_this$rootStore21 = this.rootStore) === null || _this$rootStore21 === void 0 ? void 0 : (_this$rootStore21$pla = _this$rootStore21.platformUtil) === null || _this$rootStore21$pla === void 0 ? void 0 : _this$rootStore21$pla.PLATFORM_TYPE;
                platformIsMobileApp = platform === PlatformType.APP ? true : false;

                if (redirect) {
                  this.reservationModel.reset();
                }

                if (!platformIsMobileApp) {
                  _context16.next = 13;
                  break;
                }

                notificationId = this === null || this === void 0 ? void 0 : (_this$reservationMode51 = this.reservationModel) === null || _this$reservationMode51 === void 0 ? void 0 : _this$reservationMode51.notificationID;

                if (!notificationId) {
                  _context16.next = 10;
                  break;
                }

                _context16.next = 10;
                return (_this$rootStore22 = this.rootStore) === null || _this$rootStore22 === void 0 ? void 0 : (_this$rootStore22$pla = _this$rootStore22.platformUtil) === null || _this$rootStore22$pla === void 0 ? void 0 : _this$rootStore22$pla.cancelScheduledNotification(notificationId);

              case 10:
                if (redirect) {
                  (_this$rootStore23 = this.rootStore) === null || _this$rootStore23 === void 0 ? void 0 : _this$rootStore23.platformUtil.navigateToRoute("/home");
                } else if (reload) {
                  this.validateDefaultValues();
                  this.getAllReservationRestaurants();
                }

                _context16.next = 14;
                break;

              case 13:
                if (redirect) {
                  this.isEditReservation = false;
                  this.validateDefaultValues();
                  (_this$rootStore24 = this.rootStore) === null || _this$rootStore24 === void 0 ? void 0 : _this$rootStore24.platformUtil.navigateToRoute("/reservations");
                } else if (reload) {
                  (_this$rootStore25 = this.rootStore) === null || _this$rootStore25 === void 0 ? void 0 : _this$rootStore25.platformUtil.goToURL("/reservations");
                }

              case 14:
                this._processUserProfile(this.rootStore.user.isLoggedIn, this.rootStore.user.userProfile);

                this.reservationModel.showReservationCancelSuccessModal = {
                  showModal: false,
                  redirect: false,
                  reload: false
                };

              case 16:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function handleReservationCancellationSuccessConfirm() {
        return _handleReservationCancellationSuccessConfirm.apply(this, arguments);
      }

      return handleReservationCancellationSuccessConfirm;
    }()
  }, {
    key: "handleReservationConfirmationUsingParams",
    value: function () {
      var _handleReservationConfirmationUsingParams = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(_ref5) {
        var _this$reservationMode52,
            _this$reservationMode53,
            _this8 = this;

        var confirmationNumber, resp, _this$reservationMode54, _this$reservationMode55, activeReservation;

        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                confirmationNumber = _ref5.confirmationNumber;
                this.reservationModel.confirmationNumber = confirmationNumber;
                _context17.next = 4;
                return this.getReservations(true);

              case 4:
                resp = _context17.sent;

                if (resp && ((_this$reservationMode52 = this.reservationModel) === null || _this$reservationMode52 === void 0 ? void 0 : (_this$reservationMode53 = _this$reservationMode52.activeReservations) === null || _this$reservationMode53 === void 0 ? void 0 : _this$reservationMode53.length) > 0) {
                  activeReservation = (_this$reservationMode54 = this.reservationModel) === null || _this$reservationMode54 === void 0 ? void 0 : _this$reservationMode54.activeReservations[0];
                  (_this$reservationMode55 = this.reservationModel) === null || _this$reservationMode55 === void 0 ? void 0 : _this$reservationMode55.updatevalues(activeReservation);
                } else {
                  this.rootStore.appMessages.showError("", "Unable to fetch your reservation.", null, {
                    undismissible: true,
                    okBtnText: "OK",
                    okBtnOnClick: function okBtnOnClick() {
                      _this8.rootStore.platformUtil.goToURL("/reservations");
                    }
                  });
                }

              case 6:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function handleReservationConfirmationUsingParams(_x7) {
        return _handleReservationConfirmationUsingParams.apply(this, arguments);
      }

      return handleReservationConfirmationUsingParams;
    }()
  }, {
    key: "resetReservationTime",
    value: function resetReservationTime() {
      var _this9 = this;

      var restAvailableslots = this.reservationModel.restAvailableSlotsResp;
      var reqTimeSlot = restAvailableslots === null || restAvailableslots === void 0 ? void 0 : restAvailableslots.filter(function (item) {
        var _this9$reservationMod;

        return (item === null || item === void 0 ? void 0 : item.time) === ((_this9$reservationMod = _this9.reservationModel) === null || _this9$reservationMod === void 0 ? void 0 : _this9$reservationMod.reservationTime);
      });

      if ((reqTimeSlot === null || reqTimeSlot === void 0 ? void 0 : reqTimeSlot.length) <= 0) {
        this.reservationModel.reservationTime = "";
      }
    }
  }, {
    key: "handleEditReservationLink",
    value: function () {
      var _handleEditReservationLink = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(_ref6) {
        var _this$reservationMode56,
            _this$rootStore26,
            _this$rootStore26$pla,
            _this$reservationMode58,
            _this$reservationMode59,
            _this10 = this;

        var confirmationNumber, _this$reservationMode57, platform, platformIsMobileApp, resp, _this$reservationMode60, _this$reservationMode61, _this$reservationMode62, activeReservation;

        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                confirmationNumber = _ref6.confirmationNumber;
                this.isEditReservation = true;

                if (!((_this$reservationMode56 = this.reservationModel) !== null && _this$reservationMode56 !== void 0 && _this$reservationMode56.confirmationNumber)) {
                  _context18.next = 10;
                  break;
                }

                this === null || this === void 0 ? void 0 : (_this$reservationMode57 = this.reservationModel) === null || _this$reservationMode57 === void 0 ? void 0 : _this$reservationMode57.setDetailsClone();
                _context18.next = 6;
                return this.getRestaurantTimeslots(false);

              case 6:
                _context18.next = 8;
                return this.getRestaurantAvailableSlots(false);

              case 8:
                this.resetReservationTime();
                return _context18.abrupt("return");

              case 10:
                platform = this === null || this === void 0 ? void 0 : (_this$rootStore26 = this.rootStore) === null || _this$rootStore26 === void 0 ? void 0 : (_this$rootStore26$pla = _this$rootStore26.platformUtil) === null || _this$rootStore26$pla === void 0 ? void 0 : _this$rootStore26$pla.PLATFORM_TYPE;
                platformIsMobileApp = platform === PlatformType.APP ? true : false;
                this.reservationModel.confirmationNumber = confirmationNumber;
                _context18.next = 15;
                return this.getReservations(true);

              case 15:
                resp = _context18.sent;

                if (!(resp && ((_this$reservationMode58 = this.reservationModel) === null || _this$reservationMode58 === void 0 ? void 0 : (_this$reservationMode59 = _this$reservationMode58.activeReservations) === null || _this$reservationMode59 === void 0 ? void 0 : _this$reservationMode59.length) > 0)) {
                  _context18.next = 27;
                  break;
                }

                activeReservation = (_this$reservationMode60 = this.reservationModel) === null || _this$reservationMode60 === void 0 ? void 0 : _this$reservationMode60.activeReservations[0];
                (_this$reservationMode61 = this.reservationModel) === null || _this$reservationMode61 === void 0 ? void 0 : _this$reservationMode61.updatevalues(activeReservation);
                this === null || this === void 0 ? void 0 : (_this$reservationMode62 = this.reservationModel) === null || _this$reservationMode62 === void 0 ? void 0 : _this$reservationMode62.setDetailsClone();
                _context18.next = 22;
                return this.getRestaurantTimeslots(false);

              case 22:
                _context18.next = 24;
                return this.getRestaurantAvailableSlots(false);

              case 24:
                this.resetReservationTime();
                _context18.next = 28;
                break;

              case 27:
                this.rootStore.appMessages.showError("", "Unable to fetch your reservation.", null, {
                  undismissible: true,
                  okBtnText: "OK",
                  okBtnOnClick: function okBtnOnClick() {
                    if (platformIsMobileApp) {
                      _this10.rootStore.platformUtil.navigateToRoute("/home");
                    } else {
                      _this10.rootStore.platformUtil.goToURL("/reservations");
                    }
                  }
                });

              case 28:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));

      function handleEditReservationLink(_x8) {
        return _handleEditReservationLink.apply(this, arguments);
      }

      return handleEditReservationLink;
    }()
  }, {
    key: "getReservations",
    value: function () {
      var _getReservations = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19() {
        var _this11 = this;

        var isConfirmationNumberRequired,
            _this$rootStore27,
            _this$rootStore27$use,
            _this$rootStore27$use2,
            _this$rootStore28,
            _this$rootStore28$use,
            reservationEmail,
            loggedInUserEmail,
            emailId,
            reqBodyObj,
            resp,
            _err$errors22,
            _err$errors22$,
            _err$errors23,
            _err$errors23$,
            _err$errors24,
            _err$errors24$,
            _args19 = arguments;

        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                isConfirmationNumberRequired = _args19.length > 0 && _args19[0] !== undefined ? _args19[0] : true;
                _context19.prev = 1;
                _context19.next = 4;
                return this.rootStore.platformUtil.getFromLocalStorage("RESERVATION_EMAIL");

              case 4:
                reservationEmail = _context19.sent;
                loggedInUserEmail = (_this$rootStore27 = this.rootStore) === null || _this$rootStore27 === void 0 ? void 0 : (_this$rootStore27$use = _this$rootStore27.user) === null || _this$rootStore27$use === void 0 ? void 0 : (_this$rootStore27$use2 = _this$rootStore27$use.userProfile) === null || _this$rootStore27$use2 === void 0 ? void 0 : _this$rootStore27$use2.login;
                emailId = this !== null && this !== void 0 && (_this$rootStore28 = this.rootStore) !== null && _this$rootStore28 !== void 0 && (_this$rootStore28$use = _this$rootStore28.user) !== null && _this$rootStore28$use !== void 0 && _this$rootStore28$use.isLoggedIn ? loggedInUserEmail : this.reservationModel.email || reservationEmail;
                reqBodyObj = {
                  email: emailId
                };

                if (isConfirmationNumberRequired) {
                  reqBodyObj = {
                    confirmationNumber: this.reservationModel.confirmationNumber
                  };
                }

                _context19.next = 11;
                return dpservices.Reservation.getReservations(reqBodyObj);

              case 11:
                resp = _context19.sent;

                if (!resp) {
                  _context19.next = 16;
                  break;
                }

                this.reservationModel.activeReservations = resp.activeReservations;
                this.reservationModel.pastReservations = resp.pastReservations;
                return _context19.abrupt("return", true);

              case 16:
                return _context19.abrupt("return", false);

              case 19:
                _context19.prev = 19;
                _context19.t0 = _context19["catch"](1);

                if (!(_context19.t0 instanceof dpservices.Errors.UIError)) {
                  _context19.next = 25;
                  break;
                }

                this.analyticsModel.dispatchReservationErrorEvent(_context19.t0 === null || _context19.t0 === void 0 ? void 0 : (_err$errors22 = _context19.t0.errors) === null || _err$errors22 === void 0 ? void 0 : (_err$errors22$ = _err$errors22[0]) === null || _err$errors22$ === void 0 ? void 0 : _err$errors22$.code, _context19.t0 === null || _context19.t0 === void 0 ? void 0 : (_err$errors23 = _context19.t0.errors) === null || _err$errors23 === void 0 ? void 0 : (_err$errors23$ = _err$errors23[0]) === null || _err$errors23$ === void 0 ? void 0 : _err$errors23$.message);
                this.rootStore.appMessages.showError("", _context19.t0 === null || _context19.t0 === void 0 ? void 0 : (_err$errors24 = _context19.t0.errors) === null || _err$errors24 === void 0 ? void 0 : (_err$errors24$ = _err$errors24[0]) === null || _err$errors24$ === void 0 ? void 0 : _err$errors24$.message);
                return _context19.abrupt("return", false);

              case 25:
                this.rootStore.appMessages.showError("", (_context19.t0 === null || _context19.t0 === void 0 ? void 0 : _context19.t0.message) || "Unable to fetch your reservation at the moment", null, {
                  okBtnText: "OK",
                  okBtnOnClick: function okBtnOnClick() {
                    _this11.rootStore.platformUtil.goBack();
                  }
                });
                return _context19.abrupt("return", false);

              case 27:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this, [[1, 19]]);
      }));

      function getReservations() {
        return _getReservations.apply(this, arguments);
      }

      return getReservations;
    }()
  }, {
    key: "getRestaurantFromNumber",
    value: function getRestaurantFromNumber(locationsList, restNum) {
      if (!restNum || (restNum === null || restNum === void 0 ? void 0 : restNum.length) <= 0) {
        return null;
      }

      var location = locationsList === null || locationsList === void 0 ? void 0 : locationsList.filter(function (rest) {
        var _rest$restaurantNumbe;

        return (rest === null || rest === void 0 ? void 0 : (_rest$restaurantNumbe = rest.restaurantNumber) === null || _rest$restaurantNumbe === void 0 ? void 0 : _rest$restaurantNumbe.toString()) === (restNum === null || restNum === void 0 ? void 0 : restNum.toString());
      })[0];

      if (location && Object.keys(location).length > 0) {
        return location;
      }

      return null;
    }
  }, {
    key: "prepareReservationLocation",
    value: function () {
      var _prepareReservationLocation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(locationsList, restaurantNumber) {
        var _this12 = this;

        var _this$reservationMode63, _this$reservationMode64, _this$rootStore29, _this$rootStore29$pla, restaurantNumberFromSession, restNumFromStore, platform, platformIsMobileApp, location, _location, _location$contactDeta, _location$contactDeta2, _location2;

        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                _context20.prev = 0;
                restaurantNumberFromSession = this.restNumFromSession();
                restNumFromStore = this === null || this === void 0 ? void 0 : (_this$reservationMode63 = this.reservationModel) === null || _this$reservationMode63 === void 0 ? void 0 : (_this$reservationMode64 = _this$reservationMode63.restDetails) === null || _this$reservationMode64 === void 0 ? void 0 : _this$reservationMode64.restaurantNumber;
                platform = this === null || this === void 0 ? void 0 : (_this$rootStore29 = this.rootStore) === null || _this$rootStore29 === void 0 ? void 0 : (_this$rootStore29$pla = _this$rootStore29.platformUtil) === null || _this$rootStore29$pla === void 0 ? void 0 : _this$rootStore29$pla.PLATFORM_TYPE;
                platformIsMobileApp = platform === PlatformType.APP ? true : false;

                if (restaurantNumber) {
                  location = this.getRestaurantFromNumber(locationsList, restaurantNumber);
                } else {
                  location = this.getRestaurantFromNumber(locationsList, restaurantNumberFromSession || restNumFromStore);
                }

                if (!location) {
                  _context20.next = 16;
                  break;
                }

                this.reservationModel.restDetails = location;
                this.reservationModel.selectedLocationState = (_location = location) === null || _location === void 0 ? void 0 : (_location$contactDeta = _location.contactDetail) === null || _location$contactDeta === void 0 ? void 0 : (_location$contactDeta2 = _location$contactDeta.address) === null || _location$contactDeta2 === void 0 ? void 0 : _location$contactDeta2.stateName;
                this.advanceDateIfRequired((_location2 = location) === null || _location2 === void 0 ? void 0 : _location2.closedDays);
                _context20.next = 12;
                return this.getRestaurantTimeslots();

              case 12:
                _context20.next = 14;
                return this.getRestaurantAvailableSlots();

              case 14:
                _context20.next = 18;
                break;

              case 16:
                this.reservationModel.isChangeLocationModalOpen = true;
                this.rootStore.user.obtainUserGeoCoordinates().then(function () {
                  _this12.setStateBasedOnUserCoords();
                });

              case 18:
                _context20.next = 22;
                break;

              case 20:
                _context20.prev = 20;
                _context20.t0 = _context20["catch"](0);

              case 22:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, this, [[0, 20]]);
      }));

      function prepareReservationLocation(_x9, _x10) {
        return _prepareReservationLocation.apply(this, arguments);
      }

      return prepareReservationLocation;
    }()
  }, {
    key: "advanceDateIfRequired",
    value: function advanceDateIfRequired(closedDays) {
      var _this$reservationMode65;

      var prePopulatedDate = (_this$reservationMode65 = this.reservationModel) === null || _this$reservationMode65 === void 0 ? void 0 : _this$reservationMode65.reservationDateinTimestamp;
      var currentDate = moment(); // if reservationDate comes from url params

      if (prePopulatedDate) {
        currentDate = moment(prePopulatedDate);
      } // Check if the current date is in the array


      while (closedDays.includes(currentDate.format("MM/DD/YYYY"))) {
        // Increment the current date by one day
        currentDate.add(1, "days");
      }

      this.reservationModel.reservationDateinTimestamp = currentDate;
    }
  }, {
    key: "handleReservationsAppNotification",
    value: function () {
      var _handleReservationsAppNotification = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21() {
        var _this$rootStore30, _this$rootStore30$com, _this$rootStore30$com2, _this$rootStore30$com3, _this$reservationMode66, _this$reservationMode67, _this$reservationMode68, _this$reservationMode69, _this$reservationMode70, _this$reservationMode71, _this$reservationMode72, _this$rootStore31, _this$rootStore31$pla;

        var conceptCode, notification, timeParts, dateParts, timeStamp, time, finalTimeAfterSubt, notificationId;
        return _regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                conceptCode = (_this$rootStore30 = this.rootStore) === null || _this$rootStore30 === void 0 ? void 0 : (_this$rootStore30$com = _this$rootStore30.common) === null || _this$rootStore30$com === void 0 ? void 0 : (_this$rootStore30$com2 = _this$rootStore30$com.appAttributes) === null || _this$rootStore30$com2 === void 0 ? void 0 : (_this$rootStore30$com3 = _this$rootStore30$com2.concept) === null || _this$rootStore30$com3 === void 0 ? void 0 : _this$rootStore30$com3.conceptCodeDesc;
                notification = {
                  title: "".concat(conceptCode),
                  body: "Reminder that you have a reservation for ".concat((_this$reservationMode66 = this.reservationModel) === null || _this$reservationMode66 === void 0 ? void 0 : _this$reservationMode66.noOfGuests, " guests at the ").concat(conceptCode, " - ").concat((_this$reservationMode67 = this.reservationModel.restDetails) === null || _this$reservationMode67 === void 0 ? void 0 : _this$reservationMode67.restaurantName, " ").concat(moment((_this$reservationMode68 = this.reservationModel) === null || _this$reservationMode68 === void 0 ? void 0 : _this$reservationMode68.reservationDateinTimestamp).format("LL"), " at ").concat(moment((_this$reservationMode69 = this.reservationModel) === null || _this$reservationMode69 === void 0 ? void 0 : _this$reservationMode69.reservationTime, "HH:mm:ss").format("hh:mm A"))
                };
                timeParts = ((_this$reservationMode70 = this.reservationModel) === null || _this$reservationMode70 === void 0 ? void 0 : (_this$reservationMode71 = _this$reservationMode70.reservationTime) === null || _this$reservationMode71 === void 0 ? void 0 : _this$reservationMode71.split(":")) || [];
                dateParts = moment((_this$reservationMode72 = this.reservationModel) === null || _this$reservationMode72 === void 0 ? void 0 : _this$reservationMode72.reservationDateinTimestamp).format("DD/MM/YYYY").split("/") || [];
                timeStamp = new Date(parseInt(dateParts[2]), parseInt(dateParts[1], 10) - 1, parseInt(dateParts[0]), parseInt(timeParts[0]), parseInt(timeParts[1]));
                time = timeStamp.getTime();
                finalTimeAfterSubt = moment(time).subtract(1, "h").format("x");
                _context21.next = 9;
                return (_this$rootStore31 = this.rootStore) === null || _this$rootStore31 === void 0 ? void 0 : (_this$rootStore31$pla = _this$rootStore31.platformUtil) === null || _this$rootStore31$pla === void 0 ? void 0 : _this$rootStore31$pla.scheduleLocalNotification(notification, toInteger(finalTimeAfterSubt));

              case 9:
                notificationId = _context21.sent;
                this.reservationModel.notificationID = notificationId;

              case 11:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, this);
      }));

      function handleReservationsAppNotification() {
        return _handleReservationsAppNotification.apply(this, arguments);
      }

      return handleReservationsAppNotification;
    }()
  }, {
    key: "handleReservation",
    value: function () {
      var _handleReservation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22() {
        var _this$reservationMode73, _this$reservationMode74, _this$reservationMode75, _this$rootStore32, _this$rootStore32$pla, _this$reservationMode76;

        var isReservationDateValid, isResservationTimeValid, isLocationDetailsValid, dob, valid, platform, platformIsMobileApp, errorsPos, yPos, _this$reservationMode77, navigateToError, value, keys, _i, _keys, key, _this$reservationMode78, _this$reservationMode79, bottomTabsContainReservations, offset, isRespSuccess, _this$reservationMode80, notificationId, _this$rootStore33, _this$rootStore33$pla, _this$rootStore34, _this$rootStore34$pla, _this$rootStore35, _this$rootStore35$pla, _this$reservationMode81;

        return _regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                this.isReserveClicked = this.isReserveClicked + 1;
                isReservationDateValid = this === null || this === void 0 ? void 0 : (_this$reservationMode73 = this.reservationModel) === null || _this$reservationMode73 === void 0 ? void 0 : _this$reservationMode73.reservationDateinTimestamp;
                isResservationTimeValid = this !== null && this !== void 0 && (_this$reservationMode74 = this.reservationModel) !== null && _this$reservationMode74 !== void 0 && _this$reservationMode74.reservationTime ? true : false;
                isLocationDetailsValid = this !== null && this !== void 0 && (_this$reservationMode75 = this.reservationModel) !== null && _this$reservationMode75 !== void 0 && _this$reservationMode75.restDetails ? true : false;
                dob = this !== null && this !== void 0 && this.reservationModel.dob ? true : false;
                valid = isReservationDateValid && isResservationTimeValid && isLocationDetailsValid && this.reservationModel.isValid;
                platform = this === null || this === void 0 ? void 0 : (_this$rootStore32 = this.rootStore) === null || _this$rootStore32 === void 0 ? void 0 : (_this$rootStore32$pla = _this$rootStore32.platformUtil) === null || _this$rootStore32$pla === void 0 ? void 0 : _this$rootStore32$pla.PLATFORM_TYPE;
                platformIsMobileApp = platform === PlatformType.APP ? true : false;
                errorsPos = this === null || this === void 0 ? void 0 : (_this$reservationMode76 = this.reservationModel) === null || _this$reservationMode76 === void 0 ? void 0 : _this$reservationMode76.errorsYPosition;
                yPos = null;

                if (!Object.keys(errorsPos).length) {
                  _context22.next = 40;
                  break;
                }

                navigateToError = "";
                this.reservationModel.errObj = null;

                if (isResservationTimeValid) {
                  _context22.next = 19;
                  break;
                }

                this.reservationModel.currentSelectedCTA = ReservationSelectedCTA.AVAILBALE_SLOTS;
                this.reservationModel.errObj = {
                  errKey: ReservationSelectedCTA.AVAILBALE_SLOTS,
                  errMsg: "Select the time for your reservation from the available slots."
                };
                navigateToError = "reservationTime";

                if (platformIsMobileApp) {
                  _context22.next = 19;
                  break;
                }

                return _context22.abrupt("return", ReservationBoxRefs.RESERVATION_TIME_REF);

              case 19:
                if ((_this$reservationMode77 = this.reservationModel) !== null && _this$reservationMode77 !== void 0 && _this$reservationMode77.selectedSeatingOption) {
                  _context22.next = 27;
                  break;
                }

                this.reservationModel.errObj = {
                  errKey: ReservationSelectedCTA.SEATING_OPTION,
                  errMsg: "Select the Seating Options"
                };
                navigateToError = "reservationSeatingOption";

                if (platformIsMobileApp) {
                  _context22.next = 26;
                  break;
                }

                return _context22.abrupt("return", ReservationBoxRefs.RESERVATION_SEATING_OPTION_REF);

              case 26:
                return _context22.abrupt("return", 300);

              case 27:
                value = errorsPos[navigateToError];
                keys = ["firstName", "lastName", "phoneNumber", "email"];
                _i = 0, _keys = keys;

              case 30:
                if (!(_i < _keys.length)) {
                  _context22.next = 38;
                  break;
                }

                key = _keys[_i];

                if (!this.reservationModel.errors[key]) {
                  _context22.next = 35;
                  break;
                }

                value = this.reservationModel.errorsYPosition[key] + 30;
                return _context22.abrupt("break", 38);

              case 35:
                _i++;
                _context22.next = 30;
                break;

              case 38:
                if (value) {
                  if (!!this.reservationModel.currentSelectedCTA) {
                    value += this.reservationModel.errorsYPosition["reservationDetailsError"];
                  }

                  if (this !== null && this !== void 0 && (_this$reservationMode78 = this.reservationModel) !== null && _this$reservationMode78 !== void 0 && (_this$reservationMode79 = _this$reservationMode78.seatingOptions) !== null && _this$reservationMode79 !== void 0 && _this$reservationMode79.length) {
                    bottomTabsContainReservations = this === null || this === void 0 ? void 0 : this.isBottomTabsContainReservations();
                    offset = bottomTabsContainReservations ? 580 : 550;
                    value = value + offset;
                  }
                }

                yPos = value;

              case 40:
                if (!valid) {
                  _context22.next = 57;
                  break;
                }

                if (!this.isEditReservation) {
                  _context22.next = 52;
                  break;
                }

                _context22.next = 44;
                return this === null || this === void 0 ? void 0 : this.updateReservation();

              case 44:
                isRespSuccess = _context22.sent;

                if (!platformIsMobileApp) {
                  _context22.next = 50;
                  break;
                }

                notificationId = this === null || this === void 0 ? void 0 : (_this$reservationMode80 = this.reservationModel) === null || _this$reservationMode80 === void 0 ? void 0 : _this$reservationMode80.notificationID;

                if (!notificationId) {
                  _context22.next = 50;
                  break;
                }

                _context22.next = 50;
                return (_this$rootStore33 = this.rootStore) === null || _this$rootStore33 === void 0 ? void 0 : (_this$rootStore33$pla = _this$rootStore33.platformUtil) === null || _this$rootStore33$pla === void 0 ? void 0 : _this$rootStore33$pla.cancelScheduledNotification(notificationId);

              case 50:
                _context22.next = 55;
                break;

              case 52:
                _context22.next = 54;
                return this === null || this === void 0 ? void 0 : this.createReservation();

              case 54:
                isRespSuccess = _context22.sent;

              case 55:
                console.warn("isRespSuccess", isRespSuccess);

                if (isRespSuccess) {
                  this.isReserveClicked = 0;

                  if (platformIsMobileApp) {
                    this.handleReservationsAppNotification();
                    this === null || this === void 0 ? void 0 : (_this$rootStore34 = this.rootStore) === null || _this$rootStore34 === void 0 ? void 0 : (_this$rootStore34$pla = _this$rootStore34.platformUtil) === null || _this$rootStore34$pla === void 0 ? void 0 : _this$rootStore34$pla.navigateToRoute("/reservations/reservation-confirmation");
                    this.isEditReservation = false;
                  } else {
                    this === null || this === void 0 ? void 0 : (_this$rootStore35 = this.rootStore) === null || _this$rootStore35 === void 0 ? void 0 : (_this$rootStore35$pla = _this$rootStore35.platformUtil) === null || _this$rootStore35$pla === void 0 ? void 0 : _this$rootStore35$pla.navigateToRoute("/reservations/reservation-confirmation?confirmationNumber=".concat((_this$reservationMode81 = this.reservationModel) === null || _this$reservationMode81 === void 0 ? void 0 : _this$reservationMode81.confirmationNumber, "&action=confirm"));
                  }
                }

              case 57:
                return _context22.abrupt("return", yPos);

              case 58:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, this);
      }));

      function handleReservation() {
        return _handleReservation.apply(this, arguments);
      }

      return handleReservation;
    }()
  }, {
    key: "handleDateChange",
    value: function () {
      var _handleDateChange = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23(date) {
        var _this$rootStore36, _this$rootStore36$pla, _this$reservationMode82;

        var showDatePicker, platform, platformIsMobileApp;
        return _regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                this.reservationModel.isRestAvailableSlotsLoading = true;
                this.reservationModel.reservationDateinTimestamp = date;
                showDatePicker = this.reservationModel.currentSelectedCTA === ReservationSelectedCTA.DATE;
                platform = this === null || this === void 0 ? void 0 : (_this$rootStore36 = this.rootStore) === null || _this$rootStore36 === void 0 ? void 0 : (_this$rootStore36$pla = _this$rootStore36.platformUtil) === null || _this$rootStore36$pla === void 0 ? void 0 : _this$rootStore36$pla.PLATFORM_TYPE;
                platformIsMobileApp = platform === PlatformType.APP ? true : false;

                if (!(showDatePicker && !platformIsMobileApp)) {
                  _context23.next = 7;
                  break;
                }

                return _context23.abrupt("return");

              case 7:
                if (!this.reservationModel.noOfGuests.includes("+")) {
                  _context23.next = 10;
                  break;
                }

                this.reservationModel.currentSelectedCTA = ReservationSelectedCTA.MAX_GUESTS;
                return _context23.abrupt("return");

              case 10:
                if (!((_this$reservationMode82 = this.reservationModel) !== null && _this$reservationMode82 !== void 0 && _this$reservationMode82.noOfGuests)) {
                  _context23.next = 18;
                  break;
                }

                this.reservationModel.currentSelectedCTA = ReservationSelectedCTA.AVAILBALE_SLOTS;
                _context23.next = 14;
                return this.getRestaurantTimeslots();

              case 14:
                _context23.next = 16;
                return this.getRestaurantAvailableSlots();

              case 16:
                _context23.next = 20;
                break;

              case 18:
                this.reservationModel.currentSelectedCTA = ReservationSelectedCTA.GUESTS;
                this.reservationModel.errObj = {
                  errKey: ReservationSelectedCTA.GUESTS,
                  errMsg: "Select number of guests"
                };

              case 20:
                this.reservationModel.isRestAvailableSlotsLoading = false;

              case 21:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, this);
      }));

      function handleDateChange(_x11) {
        return _handleDateChange.apply(this, arguments);
      }

      return handleDateChange;
    }()
  }, {
    key: "getAnalyticsPayload",
    value: function getAnalyticsPayload() {
      var _this$reservationMode83, _this$reservationMode84, _moment3, _this$reservationMode85;

      var requestDate = moment(this.reservationModel.reservationDateinTimestamp).format("L");
      var requestTime = moment(this.reservationModel.reservationTime, "hh:mm:s").format("hh:mm A");
      return {
        reservationType: "",
        reservationLocation: "".concat((_this$reservationMode83 = this.reservationModel) === null || _this$reservationMode83 === void 0 ? void 0 : (_this$reservationMode84 = _this$reservationMode83.restDetails) === null || _this$reservationMode84 === void 0 ? void 0 : _this$reservationMode84.restaurantNumber),
        reservationTime: requestTime,
        reservationGuests: this.reservationModel.noOfGuests,
        reservationOccasion: "",
        reservationDate: requestDate,
        dayOfWeek: ((_moment3 = moment(requestDate, "MM/DD/YYYY")) === null || _moment3 === void 0 ? void 0 : _moment3.day()) + "",
        reservationPurpose: this.reservationModel.reservationTypeIsBusiness ? "business" : "casual",
        reservationSeatingType: (_this$reservationMode85 = this.reservationModel) === null || _this$reservationMode85 === void 0 ? void 0 : _this$reservationMode85.selectedSeatingOption,
        reservationConfirmationNumber: this.reservationModel.confirmationNumber
      };
    }
  }, {
    key: "isBottomTabsContainReservations",
    value: function isBottomTabsContainReservations() {
      var _BrandRules, _this$_appAttributes;

      return (_BrandRules = new BrandRules((_this$_appAttributes = this._appAttributes) === null || _this$_appAttributes === void 0 ? void 0 : _this$_appAttributes.currentConceptCode)) === null || _BrandRules === void 0 ? void 0 : _BrandRules.bottomTabsContainReservations();
    }
  }, {
    key: "dispatchReservationStartEvent",
    value: function () {
      var _dispatchReservationStartEvent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24() {
        var _this$rootStore37, _this$rootStore37$men;

        var payload;
        return _regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                payload = {
                  "&&events": "event191:".concat((_this$rootStore37 = this.rootStore) === null || _this$rootStore37 === void 0 ? void 0 : (_this$rootStore37$men = _this$rootStore37.menuList) === null || _this$rootStore37$men === void 0 ? void 0 : _this$rootStore37$men.userUniqueId)
                };
                this.analyticsModel.dispatchReservationStartEvent(payload);

              case 2:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24, this);
      }));

      function dispatchReservationStartEvent() {
        return _dispatchReservationStartEvent.apply(this, arguments);
      }

      return dispatchReservationStartEvent;
    }()
  }, {
    key: "dispatchReservationFormStartEvent",
    value: function () {
      var _dispatchReservationFormStartEvent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee25() {
        var payload;
        return _regeneratorRuntime.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                if (!this.isReservationFormDirty && !this.isEditReservation) {
                  payload = {
                    formType: "Reservation Form"
                  };
                  this.analyticsModel.dispatchFormStartEvent(payload);
                }

                this.isReservationFormDirty = true;

              case 2:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25, this);
      }));

      function dispatchReservationFormStartEvent() {
        return _dispatchReservationFormStartEvent.apply(this, arguments);
      }

      return dispatchReservationFormStartEvent;
    }()
  }, {
    key: "dispatchReservationFormSubmitEvent",
    value: function () {
      var _dispatchReservationFormSubmitEvent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee26() {
        var payload;
        return _regeneratorRuntime.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                payload = {
                  formType: "Reservation Form"
                };
                this.analyticsModel.dispatchFormSubmitEvent(payload);

              case 2:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26, this);
      }));

      function dispatchReservationFormSubmitEvent() {
        return _dispatchReservationFormSubmitEvent.apply(this, arguments);
      }

      return dispatchReservationFormSubmitEvent;
    }()
  }, {
    key: "dispatchReservationSubmitEvent",
    value: function dispatchReservationSubmitEvent() {
      var payload = this.getAnalyticsPayload();
      this.analyticsModel.dispatchReservationSubmitEvent(payload);
    }
  }, {
    key: "dispatchReservationCompleteEvent",
    value: function dispatchReservationCompleteEvent() {
      var _this$rootStore38, _this$rootStore38$men;

      var payload = this.getAnalyticsPayload();
      this.analyticsModel.dispatchReservationCompleteEvent(_objectSpread(_objectSpread({}, payload), {}, {
        "&&events": "event192:".concat((_this$rootStore38 = this.rootStore) === null || _this$rootStore38 === void 0 ? void 0 : (_this$rootStore38$men = _this$rootStore38.menuList) === null || _this$rootStore38$men === void 0 ? void 0 : _this$rootStore38$men.userUniqueId)
      }));
    }
  }, {
    key: "dispatchReservationChangeLocationEvent",
    value: function dispatchReservationChangeLocationEvent() {
      var payload = this.getAnalyticsPayload();
      this.analyticsModel.dispatchReservationChangeLocationEvent(payload);
    }
  }, {
    key: "dispatchReservationInformationEvent",
    value: function dispatchReservationInformationEvent() {
      this.analyticsModel.dispatchReservationInformationEvent();
    }
  }, {
    key: "dispatchReservationCancelEvent",
    value: function () {
      var _dispatchReservationCancelEvent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee27() {
        var _this$rootStore39, _this$rootStore39$men;

        var payload;
        return _regeneratorRuntime.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                payload = this.getAnalyticsPayload();
                this.analyticsModel.dispatchReservationCancelEvent(_objectSpread(_objectSpread({}, payload), {}, {
                  "&&events": "event193:".concat((_this$rootStore39 = this.rootStore) === null || _this$rootStore39 === void 0 ? void 0 : (_this$rootStore39$men = _this$rootStore39.menuList) === null || _this$rootStore39$men === void 0 ? void 0 : _this$rootStore39$men.userUniqueId)
                }));

              case 2:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27, this);
      }));

      function dispatchReservationCancelEvent() {
        return _dispatchReservationCancelEvent.apply(this, arguments);
      }

      return dispatchReservationCancelEvent;
    }()
  }, {
    key: "dispatchReservationConfirmationEvent",
    value: function () {
      var _dispatchReservationConfirmationEvent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee28() {
        var payload;
        return _regeneratorRuntime.wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                payload = this.getAnalyticsPayload();
                this.analyticsModel.dispatchReservationConfirmationEvent(payload);

              case 2:
              case "end":
                return _context28.stop();
            }
          }
        }, _callee28, this);
      }));

      function dispatchReservationConfirmationEvent() {
        return _dispatchReservationConfirmationEvent.apply(this, arguments);
      }

      return dispatchReservationConfirmationEvent;
    }()
  }, {
    key: "dispatchReservationTimeNotAvailableEvent",
    value: function () {
      var _dispatchReservationTimeNotAvailableEvent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee29(preferredTime) {
        var _this$rootStore40, _this$rootStore40$men;

        var payload;
        return _regeneratorRuntime.wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                payload = this.getAnalyticsPayload();
                payload.reservationTime = preferredTime;
                this.analyticsModel.dispatchReservationTimeNotAvailableEvent(_objectSpread(_objectSpread({}, payload), {}, {
                  "&&events": "event194:".concat((_this$rootStore40 = this.rootStore) === null || _this$rootStore40 === void 0 ? void 0 : (_this$rootStore40$men = _this$rootStore40.menuList) === null || _this$rootStore40$men === void 0 ? void 0 : _this$rootStore40$men.userUniqueId)
                }));

              case 3:
              case "end":
                return _context29.stop();
            }
          }
        }, _callee29, this);
      }));

      function dispatchReservationTimeNotAvailableEvent(_x12) {
        return _dispatchReservationTimeNotAvailableEvent.apply(this, arguments);
      }

      return dispatchReservationTimeNotAvailableEvent;
    }()
  }, {
    key: "dispatchEditReservationConfirmationEvent",
    value: function () {
      var _dispatchEditReservationConfirmationEvent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee30() {
        var _this$reservationMode86, _this$reservationMode87, _this$rootStore41, _this$rootStore41$use, _this$rootStore41$use2;

        return _regeneratorRuntime.wrap(function _callee30$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                this.analyticsModel.dispatchEditReservationConfirmationEvent({
                  reservationId: this.reservationModel.confirmationNumber,
                  reservationLocation: "".concat((_this$reservationMode86 = this.reservationModel) === null || _this$reservationMode86 === void 0 ? void 0 : (_this$reservationMode87 = _this$reservationMode86.restDetails) === null || _this$reservationMode87 === void 0 ? void 0 : _this$reservationMode87.restaurantNumber),
                  profileId: (_this$rootStore41 = this.rootStore) === null || _this$rootStore41 === void 0 ? void 0 : (_this$rootStore41$use = _this$rootStore41.user) === null || _this$rootStore41$use === void 0 ? void 0 : (_this$rootStore41$use2 = _this$rootStore41$use.userProfile) === null || _this$rootStore41$use2 === void 0 ? void 0 : _this$rootStore41$use2.userId
                });

              case 1:
              case "end":
                return _context30.stop();
            }
          }
        }, _callee30, this);
      }));

      function dispatchEditReservationConfirmationEvent() {
        return _dispatchEditReservationConfirmationEvent.apply(this, arguments);
      }

      return dispatchEditReservationConfirmationEvent;
    }()
  }, {
    key: "getRestaurantPhoneNumberByType",
    value: function getRestaurantPhoneNumberByType(phoneNumbers, type) {
      if (phoneNumbers && phoneNumbers.length > 0) {
        var res = phoneNumbers.filter(function (phoneNumber) {
          return phoneNumber.type === type;
        });
        return res.length > 0 ? res[0] : null;
      } else {
        return null;
      }
    }
  }, {
    key: "getStateBasedOnCoords",
    value: function () {
      var _getStateBasedOnCoords = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee31(latitude, longitude) {
        return _regeneratorRuntime.wrap(function _callee31$(_context31) {
          while (1) {
            switch (_context31.prev = _context31.next) {
              case 0:
                return _context31.abrupt("return", dpservices.Location.getMapboxPlaceSuggestionsUsingText("", "".concat(longitude, ",").concat(latitude)));

              case 1:
              case "end":
                return _context31.stop();
            }
          }
        }, _callee31);
      }));

      function getStateBasedOnCoords(_x13, _x14) {
        return _getStateBasedOnCoords.apply(this, arguments);
      }

      return getStateBasedOnCoords;
    }()
  }, {
    key: "setStateBasedOnUserCoords",
    value: function () {
      var _setStateBasedOnUserCoords = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee32() {
        var _this$rootStore42, _this$rootStore42$use, _locationData$coords, _locationData$coords2, _results$features, _results$features$, _results$features$$co, _this$reservationMode88, _this$reservationMode89, _state2;

        var locationData, latitude, longitude, results, state, stateExistsInAllRests;
        return _regeneratorRuntime.wrap(function _callee32$(_context32) {
          while (1) {
            switch (_context32.prev = _context32.next) {
              case 0:
                if (!(this !== null && this !== void 0 && this.reservationModel.restDetails)) {
                  _context32.next = 2;
                  break;
                }

                return _context32.abrupt("return");

              case 2:
                locationData = (_this$rootStore42 = this.rootStore) === null || _this$rootStore42 === void 0 ? void 0 : (_this$rootStore42$use = _this$rootStore42.user) === null || _this$rootStore42$use === void 0 ? void 0 : _this$rootStore42$use.currentUserLocation;

                if (locationData) {
                  _context32.next = 5;
                  break;
                }

                return _context32.abrupt("return");

              case 5:
                latitude = locationData === null || locationData === void 0 ? void 0 : (_locationData$coords = locationData.coords) === null || _locationData$coords === void 0 ? void 0 : _locationData$coords.latitude;
                longitude = locationData === null || locationData === void 0 ? void 0 : (_locationData$coords2 = locationData.coords) === null || _locationData$coords2 === void 0 ? void 0 : _locationData$coords2.longitude;
                _context32.next = 9;
                return this.getStateBasedOnCoords(latitude, longitude);

              case 9:
                results = _context32.sent;
                state = null;
                results === null || results === void 0 ? void 0 : (_results$features = results.features) === null || _results$features === void 0 ? void 0 : (_results$features$ = _results$features[0]) === null || _results$features$ === void 0 ? void 0 : (_results$features$$co = _results$features$.context) === null || _results$features$$co === void 0 ? void 0 : _results$features$$co.forEach(function (dataType) {
                  if (dataType["id"].includes("region.")) {
                    state = dataType["text"].trim();
                  }
                });
                stateExistsInAllRests = (_this$reservationMode88 = this.reservationModel) === null || _this$reservationMode88 === void 0 ? void 0 : (_this$reservationMode89 = _this$reservationMode88.allReservationsStates) === null || _this$reservationMode89 === void 0 ? void 0 : _this$reservationMode89.some(function (stateName) {
                  var _state;

                  return (stateName === null || stateName === void 0 ? void 0 : stateName.toLowerCase()) === ((_state = state) === null || _state === void 0 ? void 0 : _state.toLowerCase());
                });
                if (state && stateExistsInAllRests) this.reservationModel.selectedLocationState = (_state2 = state) === null || _state2 === void 0 ? void 0 : _state2.toLowerCase();

              case 14:
              case "end":
                return _context32.stop();
            }
          }
        }, _callee32, this);
      }));

      function setStateBasedOnUserCoords() {
        return _setStateBasedOnUserCoords.apply(this, arguments);
      }

      return setStateBasedOnUserCoords;
    }()
  }, {
    key: "_getPdfMenuUrl",
    value: function () {
      var _getPdfMenuUrl2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee33(restaurantNum) {
        var pdfMenu;
        return _regeneratorRuntime.wrap(function _callee33$(_context33) {
          while (1) {
            switch (_context33.prev = _context33.next) {
              case 0:
                if (this.reservationModel.showPDFMenu) {
                  _context33.next = 2;
                  break;
                }

                return _context33.abrupt("return");

              case 2:
                _context33.next = 4;
                return dpservices.Restaurant.getRestaurantPDFMenuURL(restaurantNum);

              case 4:
                pdfMenu = _context33.sent;
                this.reservationModel.pdfMenuUrl = pdfMenu;

              case 6:
              case "end":
                return _context33.stop();
            }
          }
        }, _callee33, this);
      }));

      function _getPdfMenuUrl(_x15) {
        return _getPdfMenuUrl2.apply(this, arguments);
      }

      return _getPdfMenuUrl;
    }()
  }, {
    key: "getSeatingOptionForDefault",
    value: function getSeatingOptionForDefault(seatingOptions) {
      var _seatingOptions$filte; // if seating options are other than STANDARD or DEFAULT do not make default selection


      return (seatingOptions === null || seatingOptions === void 0 ? void 0 : (_seatingOptions$filte = seatingOptions.filter(function (option) {
        return option === "DEFAULT" || option === "STANDARD";
      })) === null || _seatingOptions$filte === void 0 ? void 0 : _seatingOptions$filte.length) > 0 ? seatingOptions === null || seatingOptions === void 0 ? void 0 : seatingOptions[0] : "";
    }
  }, {
    key: "reservationTimeNotAvailableEvent",
    value: function reservationTimeNotAvailableEvent() {
      var _this$rootStore$user, _this$rootStore$user$, _this$reservationMode90;

      var userProfileId = (_this$rootStore$user = this.rootStore.user) === null || _this$rootStore$user === void 0 ? void 0 : (_this$rootStore$user$ = _this$rootStore$user.userProfile) === null || _this$rootStore$user$ === void 0 ? void 0 : _this$rootStore$user$.userId;
      var reservationLocation = this.reservationModel.restDetails.atgRestaurantId;
      var reservationTime = moment(this.reservationModel.reservationTime, "hh:mm:s").format("hh:mm A");
      var reservationDate = moment(this.reservationModel.reservationDateinTimestamp).format("L");
      var noOfGuests = (_this$reservationMode90 = this.reservationModel) === null || _this$reservationMode90 === void 0 ? void 0 : _this$reservationMode90.noOfGuests;
      this.analyticsModel.dispatchReservationTimeNotAvailable(reservationLocation, reservationTime, reservationDate, noOfGuests, userProfileId);
    }
  }, {
    key: "isReserveClicked",
    get: function get() {
      return this._isReserveClicked;
    },
    set: function set(value) {
      var _this13 = this;

      runInAction(function () {
        _this13._isReserveClicked = value;
      });
    }
  }, {
    key: "isEditReservation",
    get: function get() {
      return this._isEditReservation;
    },
    set: function set(value) {
      var _this14 = this;

      runInAction(function () {
        _this14._isEditReservation = value;
      });
    }
  }, {
    key: "isEmailEditLink",
    get: function get() {
      return this._isEmailEditLink;
    },
    set: function set(value) {
      var _this15 = this;

      runInAction(function () {
        _this15._isEmailEditLink = value;
      });
    }
  }, {
    key: "isReservationFormDirty",
    get: function get() {
      return this._isReservationFormDirty;
    },
    set: function set(value) {
      var _this16 = this;

      runInAction(function () {
        _this16._isReservationFormDirty = value;
      });
    }
  }, {
    key: "isReservationCtaDisabled",
    get: function get() {
      var _this$reservationMode91, _this$reservationMode92, _this$reservationMode93, _this$reservationMode94;

      return (this === null || this === void 0 ? void 0 : (_this$reservationMode91 = this.reservationModel) === null || _this$reservationMode91 === void 0 ? void 0 : _this$reservationMode91.disableReservation) || (this === null || this === void 0 ? void 0 : this.isEditReservation) && (this === null || this === void 0 ? void 0 : (_this$reservationMode92 = this.reservationModel) === null || _this$reservationMode92 === void 0 ? void 0 : _this$reservationMode92.updateCTADisabled) || (this === null || this === void 0 ? void 0 : this.isEditReservation) && (this === null || this === void 0 ? void 0 : (_this$reservationMode93 = this.reservationModel) === null || _this$reservationMode93 === void 0 ? void 0 : (_this$reservationMode94 = _this$reservationMode93.restAvailableSlotsError) === null || _this$reservationMode94 === void 0 ? void 0 : _this$reservationMode94.length) > 0;
    }
  }]);

  return Reservation;
}(Base), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "_isReserveClicked", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_isEditReservation", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "_isEmailEditLink", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "_sessionDetails", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "_isReservationFormDirty", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "_appAttributes", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _applyDecoratedDescriptor(_class.prototype, "isReserveClicked", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isReserveClicked"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isEditReservation", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isEditReservation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isEmailEditLink", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isEmailEditLink"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isReservationFormDirty", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isReservationFormDirty"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isReservationCtaDisabled", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isReservationCtaDisabled"), _class.prototype)), _class);
export { Reservation as default };